<template>
  <div class="customer">
    <!-- <icon-menu></icon-menu> -->
    <el-row :gutter="24" class="card-item ml-1 mb-1">
      <el-col
        v-for="item in customerData.data"
        :xs="24"
        :md="item.span"
        :lg="{ span: '4-8' }"
        :sm="12"
        :key="item.title"
        class="py-2"
      >
        <el-card
          style="min-height: 100px"
          class="card mt-2 d-flex justify-content-center"
        >
          <div
            class="d-flex justify-content-between align-items-center flex-auto"
            @click="to(item)"
          >
            <div>
              <el-image :src="item.url" class="img-size"></el-image>
            </div>
            <div class="cursor-pointer">
              <div class="option-title pb-2">{{ item.title }}</div>
              <div class="d-flex">
                <div style="min-width: 120px">
                  <span class="option-count text-primary pr-1">{{ item.count }}</span>
                  <span class="fs-10">{{ item.unit }}</span>
                  <div class="fs-10">{{ item.label1 }}</div>
                </div>
                <div>
                  <!-- <span class="option-count text-primary pr-1">{{
                      item.target_value
                    }}</span>
                    <span class="fs-10">{{ item.unit }}</span>
                    <div class="fs-10">{{ item.label2 }}</div> -->
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="d-flex align-items-center justify-content-between pb-2">
      <div class="d-flex pb-2">
        <div class="px-3" v-if="!history_type && user.role !== 0 && user.role !== 6">
          <el-radio-group v-model="permission" size="small">
            <el-radio-button :loading="loading" label="me">{{
              user.role == 5 ? "团队客户" : "我的客户"
            }}</el-radio-button>
            <el-radio-button :loading="loading" label="other">其他客户</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <!-- <div class="d-flex align-items-center sort-order pr-3">
        <div class="pb-1 pr-1">排序方式：</div>
        <el-radio-group v-model="sortOrder">
          <el-radio class="mr-3" :label="1">客户等级</el-radio>
          <el-radio :label="2">创建日期</el-radio>
        </el-radio-group>
      </div> -->
    </div>

    <avue-crud
      v-if="viewMode === 'customer'"
      :key="crudRenderKey"
      ref="customerCrud"
      v-model="form"
      :data="data"
      :option="option"
      @row-save="create"
      @row-update="update"
      @row-del="remove"
      :before-open="beforeOpen"
      :page.sync="page"
      @on-load="changPage"
      :upload-preview="preview"
      @search-change="search"
      :before-close="afterClose"
      :table-loading="loading"
      @sort-change="sortChange"
      @selection-change="selectionChange"
    >
      <template slot="contactsSearch" slot-scope="{row}">
        <el-autocomplete
          style="width: 100%"
          v-model="row.contacts"
          :fetch-suggestions="queryContactAsync"
          placeholder="机构联系人"
          @select="handleContactSelect"
          @input="val => handleContactInputChange(val)"
          clearable
          @clear="handleContactClear"
        ></el-autocomplete>
      </template>

      <template slot="nameSearch" slot-scope="{row}">
        <el-autocomplete
          style="width: 100%"
          v-model="row.name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入客户名称"
          @select="handleSelect"
          @input="val => handleInputChange(val)"
          clearable
          @clear="handleClear"
        ></el-autocomplete>
      </template>

      <template slot="contacts.reorder" slot-scope="{ row }">
        <el-tag>{{ row.reorder }}</el-tag>
      </template>

      <template slot="business_scope" slot-scope="{ row }">
        <el-tooltip
          effect="dark"
          :content="business_scope_name(row)"
          placement="top-start"
          v-if="row.business_scope"
        >
          <div class="text-truncate cursor-pointer" style="max-width: 30vw">
            {{ business_scope_name(row) }}
          </div>
        </el-tooltip>
      </template>
      <template slot="business_scope_other_namesForm" slot-scope="{}">
        <div
          v-if="businessScopeOtherTypes.length"
          class="business-scope-other-inputs"
        >
          <div
            v-for="type in businessScopeOtherTypes"
            :key="type"
            class="business-scope-other-item"
          >
            <div v-if="hasBusinessScopeChildren(type)" class="business-scope-child-wrap">
              <el-select
                v-model="form.business_scope_other_names[type]"
                placeholder="请选择子项"
                clearable
                filterable
                class="business-scope-child-select"
                @change="handleBusinessScopeChildSelect(type)"
              >
                <el-option
                  v-for="child in businessScopeChildrenForType(type)"
                  :key="child._id"
                  :label="child.name"
                  :value="child.name"
                />
              </el-select>
              <div class="business-scope-child-prefix">终端名称：{{ type }}</div>
              <el-input
                class="business-scope-other-input"
                v-model="form.business_scope_other_names[type]"
                placeholder="请输入终端名称"
                maxlength="1000"
                clearable
                @input="handleBusinessScopeOtherNamesInput"
              />
            </div>
            <template v-else>
              <div class="business-scope-other-label">{{ type }}</div>
              <el-input
                class="business-scope-other-input"
                v-model="form.business_scope_other_names[type]"
                placeholder="请输入终端名称"
                maxlength="1000"
                clearable
                @input="handleBusinessScopeOtherNamesInput"
              />
            </template>
          </div>
        </div>
      </template>

      <template slot="business_scopeForm" slot-scope="{}">
        <el-cascader
          v-model="cascaderBusinessScope"
          :options="cascaderBusinessScopeOptions"
          :props="{
            multiple: true,
            checkStrictly: true,
            label: 'label',
            value: 'value',
            children: 'children',
          }"
          filterable
          clearable
          placeholder="请选择终端类型"
          style="width: 100%"
          @change="handleBusinessScopeCascaderChange"
        />
      </template>

      <template slot="gradeForm">
        <el-radio-group v-model="form.grade">
          <el-radio
            v-for="item in gradeDict"
            :key="item.label"
            :label="item.label"
          >
            <el-tooltip
              effect="dark"
              :content="item.displayName || item.label"
              placement="top"
            >
              <span>{{ item.label }}</span>
            </el-tooltip>
          </el-radio>
        </el-radio-group>
      </template>

      <template slot="contacts.reorder" slot-scope="{ row }">
        <el-tag>{{ row.reorder }}</el-tag>
      </template>
      <template slot="name" slot-scope="{ row }">
        <el-tooltip effect="dark" :content="row.name" placement="top-start">
          <!-- <div class="text-primary">{{ row.name }}</div> -->
          <div class="text-truncate text-primary cursor-pointer">
            {{ row.name }}
          </div>
        </el-tooltip>
      </template>

      <template slot="total" slot-scope="scope">
        <!-- <div class="text-primary">{{ scope.row.name }}</div> -->
        <!-- $router.push(`/schedules/list?customerId=${scope.row._id}&new=true`) -->
        <div
          class="text-truncate text-primary cursor-pointer"
          @click="openTotal(scope.row)"
        >
          {{ scope.row.total }}
        </div>
      </template>

      <template slot="remain" slot-scope="scope">
        <!-- <div class="text-primary">{{ scope.row.name }}</div> -->
        <div
          class="text-truncate text-primary cursor-pointer"
          @click="
            $router.push(
              `/schedules/list?customerId=${scope.row._id}&payBack_type=remain&new=true`
            )
          "
        >
          {{ scope.row.remain }}
        </div>
      </template>

      <template slot="yearTotal" slot-scope="scope">
        <!-- <div class="text-primary">{{ scope.row.name }}</div> -->
        <div
          class="text-truncate text-primary cursor-pointer"
          @click="
            $router.push(
              `/schedules/list?customerId=${scope.row._id}&cooperateDate=year&new=true`
            )
          "
        >
          {{ scope.row.yearTotal }}
        </div>
      </template>

      <template slot="user" slot-scope="scope">
        <div v-if="!Array.isArray(scope.row.user)">
          {{ scope.row.user && scope.row.user.realname }}
        </div>
        <span v-else>{{ (scope.row.user || []).map((v) => v.realname).join(",") }}</span>
      </template>
      <template slot="old_user" slot-scope="scope">
        <div v-if="!Array.isArray(scope.row.old_user)">
          {{ scope.row.old_user && scope.row.old_user.realname }}
        </div>
        <span v-else>{{
          (scope.row.old_user || []).map((v) => v.realname).join(",")
        }}</span>
      </template>

      <template slot="contacts" slot-scope="scope">
        <el-tooltip
          effect="dark"
          :content="(scope.row.contacts || []).map((v) => v.name).join('，')"
          placement="top-start"
        >
          <div class="cursor-pointer text-truncate">
            <span
              class="pr-1 contact"
              v-for="(row, index) in scope.row.contacts.slice(0, 1)"
              :key="index"
              >{{ row.name }}</span
            ><span v-if="scope.row.contacts.length > 1">...</span>
          </div>
        </el-tooltip>
      </template>

      <template slot="mobile" slot-scope="scope">
        <el-tooltip
          effect="dark"
          :content="(scope.row.contacts || []).map((v) => v.mobile).join('，')"
          placement="top-start"
        >
          <div
            style="line-height: 22px"
            v-for="(row, index) in scope.row.contacts.slice(0, 1)"
            :key="index"
          >
            {{ row.mobile }}
          </div>
          <div class="cursor-pointer text-truncate">
            <span
              class="pr-1 contact"
              v-for="(row, index) in scope.row.contacts.slice(0, 1)"
              :key="index"
              >{{ row.mobile }}</span
            >
          </div>
        </el-tooltip>
      </template>


      <!-- <template slot="contacts" slot-scope="scope"> {{scope.row.name}}</template>  -->
      <template v-if="!isBlacklistTableMode" slot-scope="scope" slot="menu">
        <el-button
          icon="iconfont icon-genjinjilu"
          @click="followUp(scope)"
          :size="scope.size"
          :type="scope.type"
          >跟进记录</el-button
        >
        <el-button
          v-if="
            (user.role == 0 || (user.role == 5 && permission === 'me')) &&
            _.get(scope.row, 'user.length', 0) > 0
          "
          icon="iconfont icon-zhuanyikehu"
          @click="relieve(scope)"
          :size="scope.size"
          :type="scope.type"
          >解除负责人</el-button
        >
        <el-button
          v-if="user.role == 0 || (user.role == 5 && permission === 'me')"
          icon="iconfont icon-fenpei1"
          @click="distribution(scope)"
          :size="scope.size"
          :type="scope.type"
          >分配负责人</el-button
        >
        <el-button
          v-if="
            (user.role == 1 || user.role == 4 || user.role == 5) &&
            _.get(scope.row, 'user.length', 0) == 0
          "
          icon="iconfont icon-fuzeren1"
          @click="takeOver(scope)"
          :size="scope.size"
          :type="scope.type"
          >接管负责人</el-button
        >
        <el-button @click="coData(scope.row)" icon="el-icon-document" type="text"
          >数据详情</el-button
        >
      </template>
      <template slot="menuLeft">
        <el-button v-if="user.role == 0 && IsPC" size="small" type="success" plain @click="exportCustomer">导出客户</el-button>
        <el-button v-if="user.role == 0 && IsPC" size="small" type="success" plain @click="exportCustomertotal">导出客户累计金额</el-button>
        <el-button v-if="user.role == 0" size="small" type="success" plain @click="exportRereservoir">导出蓄水池客户</el-button>
      </template>
      <template slot="header">
        <div v-if="user.role == 0">
          <el-button class="mb-2" @click="editRow">批量解除负责人</el-button>
          <el-button class="mb-2" @click="batchModify">批量分配负责人</el-button>
          <transition-group name="task-action-fade" tag="div" class="task-action-group">
            <el-tooltip
              v-if="showTaskActionButtons"
              key="task-create-tooltip"
              :disabled="!!customerIds.length"
              content="请先选择客户"
              placement="top"
            >
              <span class="task-action-item">
                <el-button
                  class="mb-2 task-action-button"
                  :disabled="!customerIds.length"
                  @click="openCreateTaskDialog"
                >
                  {{ taskCreateButtonText }}
                </el-button>
              </span>
            </el-tooltip>
            <span v-if="showTaskActionButtons" key="task-progress-wrap" class="task-action-item">
              <el-button class="mb-2 task-action-button" @click="openTaskProgressDrawer">
                {{ taskProgressButtonText }}
              </el-button>
            </span>
          </transition-group>
        </div>
      </template>
    </avue-crud>

    <div v-if="viewMode === 'broker'" style="margin-bottom: 10px;">
      <el-button type="primary" size="small" @click="switchToCustomerView">返回客户视图</el-button>
    </div>
    <avue-crud
      v-if="viewMode === 'broker'"
      ref="brokerCrud"
      :data="brokerData"
      :option="brokerOption"
      :page.sync="brokerPage"
      :table-loading="brokerLoading"
      @on-load="fetchBrokerData"
      @sort-change="brokerSortChange"
    >
      <template slot="menu" slot-scope="scope">
        <el-button icon="el-icon-document" type="text" size="small" @click="openBrokerAnalysis(scope.row)">
          数据分析
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="数据分析"
      :visible.sync="showBrokerDrawer"
      width="95%"
      align="center"
    >
      <el-table
        :data="brokerAnalysisData"
        border
        style="width: 100%"
        height="600"
        size="mini"
        :header-cell-style="getBrokerAnalysisHeaderStyle"
      >
        <el-table-column prop="brokerName" label="团队/经纪人" fixed="left" width="120" align="center"></el-table-column>

        <el-table-column label="客户等级（等级区间）" align="center">
          <el-table-column prop="v0_total" label="全量客户数" width="100" align="center"></el-table-column>
          <el-table-column prop="v0_year_deal" label="本年成交客户（有效户）" width="160" align="center"></el-table-column>
          <el-table-column prop="v0_year_contacted" label="本年建联客户数" width="130" align="center"></el-table-column>
          <el-table-column prop="v0_uncontacted_3m" label="3个月未建联客户数" width="150" align="center"></el-table-column>
          <el-table-column prop="v0_undeal_12m" label="12个月未成交客户数（存量睡眠）" width="220" align="center"></el-table-column>
          <el-table-column prop="v0_year_activated" label="本年存量睡眠激活客户数" width="180" align="center"></el-table-column>
        </el-table-column>

        <el-table-column label="V1 (0-10万, 不含)" align="center">
          <el-table-column prop="v1_count" label="客户量" width="80" align="center"></el-table-column>
          <el-table-column prop="v1_month_deal" label="本月成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v1_month_sales" label="本月销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v1_year_deal" label="本年成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v1_year_sales" label="本年销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v1_month_new" label="本月新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v1_month_new_sales" label="本月新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v1_year_new" label="本年新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v1_year_new_sales" label="本年新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v1_month_contacted" label="本月建联客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v1_month_uncontacted" label="本月未建联客户数" width="130" align="center"></el-table-column>
        </el-table-column>

        <el-table-column label="V2 (10-30万, 不含)" align="center">
          <el-table-column prop="v2_count" label="客户量" width="80" align="center"></el-table-column>
          <el-table-column prop="v2_month_deal" label="本月成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v2_month_sales" label="本月销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v2_year_deal" label="本年成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v2_year_sales" label="本年销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v2_month_new" label="本月新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v2_month_new_sales" label="本月新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v2_year_new" label="本年新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v2_year_new_sales" label="本年新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v2_month_contacted" label="本月建联客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v2_month_uncontacted" label="本月未建联客户数" width="130" align="center"></el-table-column>
        </el-table-column>

        <el-table-column label="V3 (30-50万, 不含)" align="center">
          <el-table-column prop="v3_count" label="客户量" width="80" align="center"></el-table-column>
          <el-table-column prop="v3_month_deal" label="本月成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v3_month_sales" label="本月销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v3_year_deal" label="本年成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v3_year_sales" label="本年销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v3_month_new" label="本月新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v3_month_new_sales" label="本月新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v3_year_new" label="本年新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v3_year_new_sales" label="本年新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v3_month_contacted" label="本月建联客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v3_month_uncontacted" label="本月未建联客户数" width="130" align="center"></el-table-column>
        </el-table-column>

        <el-table-column label="V4 (50-100万, 不含)" align="center">
          <el-table-column prop="v4_count" label="客户量" width="80" align="center"></el-table-column>
          <el-table-column prop="v4_month_deal" label="本月成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v4_month_sales" label="本月销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v4_year_deal" label="本年成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v4_year_sales" label="本年销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v4_month_new" label="本月新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v4_month_new_sales" label="本月新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v4_year_new" label="本年新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v4_year_new_sales" label="本年新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v4_month_contacted" label="本月建联客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v4_month_uncontacted" label="本月未建联客户数" width="130" align="center"></el-table-column>
        </el-table-column>

        <el-table-column label="V5 (100-300万, 不含)" align="center">
          <el-table-column prop="v5_count" label="客户量" width="80" align="center"></el-table-column>
          <el-table-column prop="v5_month_deal" label="本月成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v5_month_sales" label="本月销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v5_year_deal" label="本年成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v5_year_sales" label="本年销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v5_month_new" label="本月新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v5_month_new_sales" label="本月新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v5_year_new" label="本年新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v5_year_new_sales" label="本年新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v5_month_contacted" label="本月建联客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v5_month_uncontacted" label="本月未建联客户数" width="130" align="center"></el-table-column>
        </el-table-column>

        <el-table-column label="V6 (300万以上)" align="center">
          <el-table-column prop="v6_count" label="客户量" width="80" align="center"></el-table-column>
          <el-table-column prop="v6_month_deal" label="本月成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v6_month_sales" label="本月销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v6_year_deal" label="本年成交客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v6_year_sales" label="本年销售额（万）" width="130" align="center"></el-table-column>
          <el-table-column prop="v6_month_new" label="本月新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v6_month_new_sales" label="本月新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v6_year_new" label="本年新增客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v6_year_new_sales" label="本年新增销售额（万）" width="150" align="center"></el-table-column>
          <el-table-column prop="v6_month_contacted" label="本月建联客户数" width="120" align="center"></el-table-column>
          <el-table-column prop="v6_month_uncontacted" label="本月未建联客户数" width="130" align="center"></el-table-column>
        </el-table-column>
      </el-table>
    </el-dialog>

    <div class="d-flex">
      <import :doImport="doImport" :parseItems="parseItems" class="pr-1 import"></import>

      <el-form
        v-if="user.role == 0 && IsPC"
        class="pl-2 import"
        ref="form"
        label-width="80px"
        inline
        @submit.native.prevent="doImportFollowUp"
      >
        <div class="d-flex mb-3">
          <div class="d-flex align-items-center">
            <div class="pr-3 pl-1 fs-9 import-ex">导入跟进记录</div>
            <div class="a-upload">
              <span>点击上传</span>
              <input @input="parseFile" type="file" />
            </div>
          </div>
          <div class="ml-2">
            <el-button size="small" type="primary" native-type="submit">导入</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog
      title="跟进记录"
      :visible.sync="dialogVisible"
      width="74%"
      :before-close="dataClose"
    >
      <el-card class="mb-4">
        <el-form :inline="true">
          <el-form-item label="跟进日期">
            <el-date-picker
              v-model="record.time"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="沟通方式">
            <el-select v-model="record.contact_way" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系人">
            <el-select filterable v-model="record.contact" placeholder="请选择">
              <el-option
                v-for="item in formRow.contacts"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐教师">
            <el-select filterable v-model="record.teachers" multiple placeholder="请选择">
              <el-option
                v-for="item in teacherOptions"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进人">
            <el-select filterable v-model="record.user" placeholder="请选择">
              <el-option
                v-for="item in superintendents"
                :key="item.id"
                :label="item.realname"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="跟进类型">
            <el-radio v-model="record.followUp_type" label="daily" size="large"
              >日常业务对接</el-radio
            >
            <el-radio v-model="record.followUp_type" label="keyPoint" size="large"
              >重点业务机会</el-radio
            >
          </el-form-item>

          <el-input
            v-model="record.content"
            type="textarea"
            placeholder="请输入沟通内容"
          ></el-input>

          <div class="text-center mt-2">
            <el-button type="primary" @click="onSubmit()">提交</el-button>
          </div>
        </el-form>
        <!-- <avue-form v-model="record" :option="records"> </avue-form> -->
      </el-card>
      <div class="block">
        <el-timeline v-if="_.get(formRow, 'history.length', 0) > 0">
          <!-- <div v-for="v in data" :key="v._id"> -->
          <el-timeline-item
            v-for="(item, index) in history"
            :key="item.__historyKey"
            :timestamp="item.submitedAt | formatDate"
            placement="top"
          >
            <el-card>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="history-info">
                    <div class="pr-2" v-if="item.realname">
                      跟进人：
                      <span>{{ item.realname }}</span>
                      <!-- <span>{{ _.get(formRow, "history_user[0].realname") }}</span> -->
                    </div>

                    <div class="pr-2" v-else-if="item.user">
                      跟进人：
                      <span>{{ _.get(item, "user.realname") }}</span>
                    </div>

                    <div class="pr-2" v-else>
                      跟进人：
                      <!-- {{item}}

                      {{formRow}}-->
                      <!-- <span>{{ _.get(formRow, "user[0].realname") }}</span> -->
                      <span>{{ _.get(formRow, "history_user[0].realname") }}</span>
                    </div>
                    跟进日期：
                    <span class="createdAt">
                      {{ item.time | formatDateY }}
                    </span>
                    <div class="pdl-3">
                      <span>沟通方式：</span>
                      <span class="text-danger font-weight-bold">
                        {{ item.contact_way }}
                      </span>
                    </div>
                    <div class="pdl-3">
                      <span>联系人：</span>
                      <span>{{ item.contact }}</span>
                    </div>

                    <div class="pdl-3">
                      <span>跟进类型：</span>
                      <span class="text-danger font-weight-bold">{{ followUpType(item.followUp_type) }}</span>
                    </div>
                  </div>
                  <div class="pt-3">{{ item.content }}</div>
                </div>
                <div class="pr-4">
                  <el-button
                    @click="detach(index)"
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div v-else class="text-center pb-2">暂无记录</div>
      </div>
    </el-dialog>

    <el-dialog
      title="分配负责人"
      :visible.sync="dialogPrincipal"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <avue-form v-model="obj" :option="dialogOption" @submit="submit"></avue-form>
      </div>
    </el-dialog>

    <el-dialog
      title="批量分配负责人"
      :visible.sync="dialogAssigningUser"
      width="30%"
      :before-close="closeAssigningUser"
    >
      <div>
        <avue-form
          v-model="assigningUser"
          :option="dialogOption"
          @submit="assigningSubmit"
        ></avue-form>
      </div>
    </el-dialog>

    <el-dialog
      title="导出"
      :visible.sync="dialogExport"
      width="50%"
      :before-close="handleClose"
    >
      <avue-form
        v-model="exportForm"
        :option="exportOption"
        @submit="exportSubmit"
      ></avue-form>
    </el-dialog>

    <el-dialog
      title="导出"
      :visible.sync="dialogtotalExport"
      width="50%"
      :before-close="handleCloseTotal"
    >
      <avue-form
        v-model="exportotaltForm"
        :option="exportOption"
        @submit="exportTotalSubmit"
      ></avue-form>
    </el-dialog>
    <el-dialog
      title="导出"
      :visible.sync="showRreservoir"
      width="50%"
      :before-close="showRreservoirhandleClose"
    >
      <avue-form
        v-model="reservoirFrom"
        :option="exportOption"
        @submit="exportSubmitR"
      ></avue-form>
    </el-dialog>

    <el-dialog
      :title="obj.name"
      :visible.sync="dialogData"
      width="80%"
      align="center"
      :before-close="dataClose"
    >
      <div class="" v-loading="coiLoading">
        <div class="text-right mb-3">
          <span class="mr-2 fs-9">当前数据年份</span>
          <el-date-picker
            style="width: 120px"
            v-model="customerQuery.year"
            type="year"
            :clearable="false"
            value-format="yyyy"
            placeholder="请选择年份"
          />
        </div>
        <div class="mb-4">
          <avue-data-panel :option="customerOption"></avue-data-panel>
        </div>
        <el-row :gutter="20">
          <el-col :span="12" :xl="12" :md="12" :lg="12">
            <div ref="chart1" style="height: 280px; width: 100%"></div>
          </el-col>
          <el-col :span="12" :xl="12" :md="12" :lg="12">
            <div ref="chart2" style="height: 280px; width: 100%"></div>
          </el-col>
        </el-row>
        <div class="mb-2" style="text-align: left; font-weight: bold; font-size: 16px; margin-top: 20px;">授课记录情况</div>
        <el-table class="mt-3" :data="customers" stripe border style="width: 100%">
          <el-table-column prop="_id.name" label="终端客户">
            <template slot-scope="{ row }">
              <span v-if="row.terminal_name">{{ row.terminal_name }}</span>
              <span v-else>客户已删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="teacher" label="讲师">
            <template slot-scope="{ row }">
              <span v-if="row.teacher">{{ row.teacher.name }}</span>
              <span v-else>讲师已删除</span>
            </template>
          </el-table-column>

          <el-table-column prop="times" label="上课日期">
            <template slot-scope="{ row }">
              <el-tooltip
                effect="dark"
                :content="
                  _.get(row, 'times', [])
                    .map((v) => $filters.formatDateT(v))
                    .join('，')
                "
                placement="top-start"
              >
                <!-- <div v-for="(item, i) in _.get(row, 'times', [])" :key="i">
                  {{ $filters.formatDateT(item) }}
                </div>-->

                <div
                  class="cursor-pointer"
                  :class="IsPC ? 'text-truncate1' : 'text-truncate'"
                  style="max-width: 20vw"
                >
                  <!-- {{ scope.row.times && scope.row.times.join("<br>") | formatDateT
                  }}-->

                  <div
                    class="times"
                    v-for="(item, i) in _.get(row, 'times', []).slice(0, 4)"
                    :key="i"
                  >
                    <span :key="i">{{ $filters.formatDateT(item) }}</span>
                    <!-- <br :key="`br-` + i" /> -->
                  </div>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="post" label="课程名称"> </el-table-column>
          <el-table-column prop="category" label="授课类别"> </el-table-column>
          <el-table-column prop="order_amount" label="订单总额"> </el-table-column>
        </el-table>

        <div class="mt-3">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="customerQuery.page"
            layout="total, prev, pager, next"
            :total="customerPage.total"
          >
          </el-pagination>
        </div>
        <CustomerChart
          :customer="obj._id"
          :query="{ search_year: customerQuery.year }"
          v-if="obj._id"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="累计金额数据"
      :visible.sync="showTotal"
      width="50%"
      :before-close="closeTotal"
    >
      <avue-crud :data="totalData" :option="totalOption">
        <template slot-scope="scope" slot="menu">
          <el-button @click="watchTotal(scope.row)" type="text">查看</el-button>
        </template>
      </avue-crud>

      <p class="my-2">总计：{{ totalAmount }}</p>
    </el-dialog>

    <el-dialog
      :title="taskCreateDialogTitle"
      :visible.sync="taskCreateDialog"
      width="760px"
      @close="resetTaskCreateState"
    >
      <div class="task-create-selected mb-3">
        <div class="mb-2">已选择 {{ selectedTaskCustomers.length }} 个客户</div>
        <el-table
          :data="selectedTaskCustomers"
          border
          size="mini"
          max-height="220"
        >
          <el-table-column prop="name" label="客户名称" min-width="180" />
          <el-table-column label="当前负责人" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ _.get(row, "user[0].realname", "暂无负责人") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最后联系时间" min-width="160">
            <template slot-scope="{ row }">
              <span>
                {{
                  _.get(row, "history[0].time")
                    ? dayjs(_.get(row, "history[0].time")).format("YYYY-MM-DD HH:mm")
                    : "暂无"
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form
        ref="taskForm"
        :model="taskForm"
        :rules="taskFormRules"
        label-width="110px"
      >
        <el-form-item v-if="!isActivityTaskContext" prop="taskType" class="task-type-form-item">
          <div class="task-type-label">任务类型</div>
          <el-radio-group v-model="taskForm.taskType" class="task-type-radio-group">
            <el-radio
              v-for="item in linkTaskTypeOptions"
              :key="item.label"
              :label="item.label"
            >
              {{ item.displayName || item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="taskContentLabel" prop="content">
          <el-input
            v-model="taskForm.content"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            :placeholder="taskContentPlaceholder"
          />
        </el-form-item>
        <el-form-item label="计划完成时间" prop="plannedAt">
          <el-date-picker
            v-model="taskForm.plannedAt"
            type="datetime"
            value-format="timestamp"
            format="yyyy-MM-dd HH:mm"
            placeholder="请选择计划完成时间"
          />
        </el-form-item>
        <el-form-item label="派单给负责人">
          <el-switch v-model="taskForm.assignToOwner" />
        </el-form-item>
        <el-form-item
          v-if="!taskForm.assignToOwner"
          label="接收人"
          prop="receiverId"
        >
          <el-select
            v-model="taskForm.receiverId"
            filterable
            clearable
            placeholder="请选择接收人"
            style="width: 100%"
          >
            <el-option
              v-for="item in taskReceivers"
              :key="item._id"
              :label="item.realname"
              :value="item._id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="taskCreateResult" class="task-result-box mt-3">
        <div>
          结果摘要：成功 {{ taskCreateResult.successCount }} 条，失败
          {{ taskCreateResult.failCount }} 条
        </div>
        <div v-if="taskCreateResult.failCount" class="mt-2">
          <div
            v-for="item in taskCreateResult.failures"
            :key="`${item.customerId}-${item.reason}`"
            class="task-result-item"
          >
            {{ item.customerName || item.customerId }}：{{ item.reason }}
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="taskCreateDialog = false">取消</el-button>
        <el-button type="primary" :loading="taskSubmitting" @click="submitTaskCreate">
          确认
        </el-button>
      </span>
    </el-dialog>

    <el-drawer
      :title="taskProgressDrawerTitle"
      :visible.sync="taskProgressDrawer"
      size="55%"
      destroy-on-close
    >
      <div class="task-progress-wrap">
        <el-form :inline="true" class="mb-3">
          <el-form-item label="日期区间">
            <el-date-picker
              v-model="taskProgressFilter.daterange"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item :label="taskProgressReceiverLabel">
            <el-select
              v-model="taskProgressFilter.receiverId"
              clearable
              filterable
              placeholder="全部"
            >
              <el-option
                v-for="item in taskReceivers"
                :key="item._id"
                :label="item.realname"
                :value="item._id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshTaskProgress">刷新</el-button>
            <el-button @click="resetTaskProgressFilter">重置</el-button>
          </el-form-item>
        </el-form>

        <div class="task-progress-cards" v-loading="taskProgressLoading">
          <div
            class="task-progress-card"
            :class="{ active: taskProgressFilter.status === 'all' }"
            @click="changeTaskStatusFilter('all')"
          >
            <div class="task-progress-label">总任务数</div>
            <div class="task-progress-value">{{ taskProgressStats.total }}</div>
          </div>
          <div
            class="task-progress-card success"
            :class="{ active: taskProgressFilter.status === 'completed' }"
            @click="changeTaskStatusFilter('completed')"
          >
            <div class="task-progress-label">已完成数</div>
            <div class="task-progress-value">{{ taskProgressStats.completed }}</div>
          </div>
          <div
            class="task-progress-card warning"
            :class="{ active: taskProgressFilter.status === 'processing' }"
            @click="changeTaskStatusFilter('processing')"
          >
            <div class="task-progress-label">进行中数</div>
            <div class="task-progress-value">{{ taskProgressStats.processing }}</div>
          </div>
          <div
            class="task-progress-card danger"
            :class="{ active: taskProgressFilter.status === 'overdue' }"
            @click="changeTaskStatusFilter('overdue')"
          >
            <div class="task-progress-label">已逾期数</div>
            <div class="task-progress-value">{{ taskProgressStats.overdue }}</div>
          </div>
        </div>

        <el-alert
          v-if="taskProgressStats.overdue"
          :title="`当前有 ${taskProgressStats.overdue} 个逾期任务，请优先处理`"
          type="error"
          :closable="false"
          class="mb-3"
        />

        <div class="task-progress-bar mb-3">
          <div class="task-progress-rate-text">
            完成率 {{ taskProgressPercent }}%
          </div>
          <el-progress
            :percentage="taskProgressPercent"
            :color="taskProgressColor"
          />
        </div>

        <el-table
          :data="taskProgressList"
          border
          size="mini"
          v-loading="taskProgressLoading"
          :empty-text="taskProgressEmptyText"
        >
          <template slot="empty">
            <el-empty :description="taskProgressEmptyText" />
          </template>
          <el-table-column prop="customerName" label="客户名称" min-width="160" />
          <el-table-column
            v-if="isActivityTaskContext"
            label="任务状态"
            min-width="110"
          >
            <template slot-scope="{ row }">
              <el-tag :type="taskStatusTag(row)">
                {{ taskStatusText(row.status, row.isOverdue) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isActivityTaskContext"
            prop="receiverName"
            label="负责人"
            min-width="100"
          />
          <el-table-column
            v-else
            prop="receiverName"
            label="接收人"
            min-width="100"
          />
          <el-table-column v-if="!isActivityTaskContext" label="当前状态" min-width="110">
            <template slot-scope="{ row }">
              <el-tag :type="taskStatusTag(row)">
                {{ taskStatusText(row.status, row.isOverdue) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isActivityTaskContext"
            label="创建时间"
            min-width="160"
          >
            <template slot-scope="{ row }">
              <span>{{ dayjs(row.createdAt).format("YYYY-MM-DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isActivityTaskContext"
            label="完成率"
            min-width="100"
          >
            <template slot-scope="{ row }">
              <span>{{ taskRowCompletionRate(row) }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            label="计划完成时间"
            min-width="160"
          >
            <template slot-scope="{ row }">
              <span>{{ dayjs(row.plannedAt).format("YYYY-MM-DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100">
            <template slot-scope="{ row }">
              <el-button type="text" @click="openTaskDetail(row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="mt-3 text-right">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page.sync="taskProgressFilter.page"
            :page-size="taskProgressFilter.limit"
            :total="taskProgressTotal"
            @current-change="refreshTaskProgress"
          />
        </div>
      </div>
    </el-drawer>

    <el-dialog
      :title="taskDetailDialogTitle"
      :visible.sync="taskDetailDialog"
      width="560px"
      append-to-body
    >
      <div v-loading="taskDetailLoading" v-if="taskDetail && taskDetail._id">
        <div class="task-detail-row">
          <span>客户名称</span>
          <strong>{{ taskDetail.customerName || "-" }}</strong>
        </div>
        <div class="task-detail-row">
          <span>任务类型</span>
          <strong>{{ taskDetailType || "-" }}</strong>
        </div>
        <div class="task-detail-row">
          <span>接收人</span>
          <strong>{{ taskDetail.receiverName || "-" }}</strong>
        </div>
        <div class="task-detail-row">
          <span>负责人</span>
          <strong>{{ taskDetail.ownerName || "暂无负责人" }}</strong>
        </div>
        <div class="task-detail-row">
          <span>计划完成时间</span>
          <strong>{{ dayjs(taskDetail.plannedAt).format("YYYY-MM-DD HH:mm") }}</strong>
        </div>
        <div class="task-detail-row">
          <span>最后联系时间</span>
          <strong>
            {{
              taskDetail.lastContactTime
                ? dayjs(taskDetail.lastContactTime).format("YYYY-MM-DD HH:mm")
                : "暂无"
            }}
          </strong>
        </div>
        <div class="task-detail-row">
          <span>任务状态</span>
          <el-tag :type="taskStatusTag(taskDetail)">
            {{ taskStatusText(taskDetail.status, taskDetail.isOverdue) }}
          </el-tag>
        </div>
        <div class="task-detail-text mt-3">{{ taskDetail.content || "-" }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as dayjs from "dayjs";
import CustomerChart from "../../components/CustomerChart.vue";
const importField = [
  {
    label: "客户名称",
    value: "客户名称",
  },
  {
    label: "客户状态",
    value: "客户状态",
  },
  {
    label: "客户来源",
    value: "客户来源",
  },
  {
    label: "客户等级",
    value: "客户等级",
  },
  {
    label: "所属城市",
    value: "所属城市",
  },
  {
    label: "详细地址",
    value: "详细地址",
  },
  {
    label: "备注",
    value: "备注",
  },
  {
    label: "联系人",
    value: "联系人",
  },
  {
    label: "跟进记录",
    value: "跟进记录",
  },
  {
    label: "距上次联系天数",
    value: "距上次联系天数",
  },
  {
    label: "距上次下单天数",
    value: "距上次下单天数",
  },
  {
    label: "今年累计合作金额",
    value: "今年累计合作金额",
  },
  {
    label: "累计合作金额",
    value: "累计合作金额",
  },
  {
    label: "负责人",
    value: "负责人",
  },
  {
    label: "创建时间",
    value: "创建时间",
  },
];
export default {
  data() {
    var mobile = (rule, value, callback) => {
      const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
      const landline = /0\d{2,3}-\d{7,8}/;
      if (reg.test(value) || landline.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };
    var backupMobileValidator = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      const reg = /^1[0-9-]{10,19}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("长度11-20位、仅数字与“-”符号、首位为1"));
      }
    };
    return {
      brokerFilterId: null,
      viewMode: 'customer',
      brokerData: [],
      brokerLoading: false,
      brokerPage: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      brokerSortOrder: -1,
      previousBrokerId: null,
      showBrokerDrawer: false,
      currentBrokerId: null,
      brokerAnalysisData: [],
      brokerOption: {
        size: "mini",
        align: "center",
        border: true,
        index: true,
        indexLabel: "序号",
        header: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 100,
        column: [
          { label: "经纪人姓名", prop: "realname" },
          { label: "所属团队", prop: "group_name" },
          { label: "累计推荐客户数", prop: "totalCustomerCount" },
          { label: "本月新增推荐客户数", prop: "monthNewCount" },
          { label: "本年新增推荐客户数", prop: "yearNewCount" },
          { label: "本月推荐客户成交数", prop: "monthDealCount" },
          { label: "本年推荐客户成交数", prop: "yearDealCount" },
          { label: "本月推荐客户未成交数", prop: "monthNotDealCount" },
          { label: "本年推荐客户未成交数", prop: "yearNotDealCount" },
          { label: "近90天未跟进客户数", prop: "notContact90DaysCount" },
          { label: "当年合作金额", prop: "yearCooperationAmount", sortable: "custom" }
        ]
      },
      showTotal: false,
      showTotalQuery: {
        customer: "",
      },
      searchCustomerId: null,
      selectedItemName: null,
      isBlacklistTableMode: false,
      crudRenderKey: 0,
      defaultCrudSelection: true,
      defaultCrudMenuWidth: 300,
      defaultCrudColumns: [],
      businessScopeItemMap: {},
      businessScopeChildrenMap: {},
      cascaderBusinessScope: [],
      cascaderBusinessScopeOptions: [],
      defaultCrudColumnState: [],
      totalAmount: 0,
      totalData: [],
      totalOption: {
        size: "mini",
        align: "center",
        border: true,
        index: true,
        indexLabel: "序号",
        searchMenuSpan: 4,
        header: true,
        dialogClickModal: false,
        emptyBtn: false,
        border: true,
        menuWidth: 160,
        translate: false,
        editBtn: false,
        addBtn: false,
        refreshBtn: false,
        searchShowBtn: false,
        columnBtn: false,
        copyBtn: false,
        delBtn: false,
        column: [
          {
            label: "年份",
            prop: "year",
            border: true,
            slot: true,
          },
          {
            label: "总金额",
            prop: "total",
            border: true,
            span: 24,
            slot: true,
          },
        ],
      },
      dataDate: {
        dataMonth: new Date(),
      },
      showRreservoir: false,
      customerQuery: {
        year: new Date(),
        limit: 10,
        page: 1,
        where: {
          type: null,
        },
      },
      assigningUser: {},
      dialogAssigningUser: false,
      customerIds: [],
      taskCreateDialog: false,
      taskSubmitting: false,
      taskCreateResult: null,
      taskActionSceneReady: false,
      linkTaskTypeOptions: [],
      taskForm: {
        content: "",
        plannedAt: dayjs().add(72, "hour").valueOf(),
        assignToOwner: true,
        receiverId: "",
        taskType: "",
      },
      taskFormRules: {
        taskType: [
          {
            required: true,
            message: "请选择任务类型",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写任务内容",
            trigger: "blur",
          },
          {
            max: 500,
            message: "任务内容最多 500 字",
            trigger: "blur",
          },
        ],
        plannedAt: [
          {
            required: true,
            message: "请选择计划完成时间",
            trigger: "change",
          },
        ],
        receiverId: [
          {
            validator: (rule, value, callback) => {
              if (!this.taskForm.assignToOwner && !value) {
                callback(new Error("请选择接收人"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },
      taskProgressDrawer: false,
      taskProgressLoading: false,
      taskProgressTimer: null,
      taskProgressTotal: 0,
      taskProgressList: [],
      taskProgressStats: {
        total: 0,
        completed: 0,
        processing: 0,
        overdue: 0,
      },
      taskProgressFilter: {
        daterange: [],
        receiverId: "",
        status: "all",
        page: 1,
        limit: 10,
      },
      taskDetailDialog: false,
      taskDetailLoading: false,
      taskDetailType: "",
      taskDetail: {},
      customerOption: {},
      hascustomer: false,
      monthlySalesChart: null,
      monthlyImplementationChart: null,
      customerData: [],
      sortOrder: 1,
      dialogEdit: false,
      dialogData: false,
      coiLoading: false,
      dialogExport: false,
      history_type: null,
      obj: {},
      cities: [],
      grade: null,
      gradeDict: [],
      wname: null,
      userName: null,
      ids: null,
      createdAt: null,
      permission: "me",
      customerPage: {
        total: 0,
      },
      customers: [],
      customerId: undefined,
      query: {
        sort: { yearTotal: -1 },
        collation: { locale: "zh" },
        limit: 20,
        where: {
          isBlacklist: 0,
          // days_without_order: { $gt: 90 },
        },
      },
      where: null,
      from: {},
      page: {
        total: 0,
        pageSize: 20,
      },
      form: {
        dynamic: [
          {
            reorder: 1,
            select: 1,
          },
          {
            reorder: 2,
            select: 2,
          },
        ],
      },
      formRow: {},
      record: {
        contact: "",
        contact_way: "",
        time: "",
        content: "",
        followUp_type: "daily",
        submitedAt: new Date(),
        teachers: [],
      },
      exportOption: {
        translate: false,
        column: [
          {
            label: "日期范围",
            prop: "daterange",
            type: "daterange",
            startPlaceholder: "选择导出的开始时间",
            endPlaceholder: "选择导出的结束时间",
            span: 12,
            valueFormat: "timestamp",
            rules: [
              {
                required: true,
                message: "请选择导出的日期范围",
                trigger: "blur",
              },
            ],
          },
          {
            label: "导出内容",
            prop: "field",
            type: "tree",
            span: 12,
            multiple: true,
            rules: [
              {
                required: true,
                message: "请选择导出的内容",
                trigger: "blur",
              },
            ],
            dicData: importField,
          },
        ],
      },
      options: [],
      dialogVisible: false,
      dialogPrincipal: false,
      data: [],
      loading: true,
      superintendents: [],
      users: [],
      exportForm: {
        daterange: [],
        field: [],
      },
      reservoirFrom: {
        daterange: [],
        field: [],
      },
      teacherOptions: [],
      option: {
        reserveSelection: true,
        selection: true,
        border: true,
        menu: true,
        tree: true,
        expandLevel: 2,
        headerAlign: "center",
        dialogWidth: "90%",
        menuWidth: 300,
        searchMenuSpan: 5,
        viewBtn: true,
        align: "center",
        index: true,
        indexLabel: "序号",
        dialogClickModal: false,
        translate: false,
        column: [
          {
            label: "客户名称",
            prop: "name",
            search: true,
            searchSlot: true,
            searchLabelWidth: 100,
            sortable: true,
            allowCreate: true,
            placeholder: "请填写机构营业执照名称",
            defaultfirstOption: true,
            rules: [
              {
                required: true,
                message: "请输入客户名称",
                trigger: "blur",
              },
            ],
          },

          // {
          //   label: "联系人",
          //   prop: "name",
          //   props: {
          //     lable: "lable",
          //     value: "value",
          //   },
          //   search: true,
          // },

          // {
          //   label: "客户名称",
          //   prop: "searchName",
          //   props: {
          //     lable: "lable",
          //     value: "value",
          //   },
          //   display:false,
          //   search: true,
          //   hide:true,
          //   rules: [
          //     {
          //       required: true,
          //       message: "请输入客户名称",
          //       trigger: "blur",
          //     },
          //   ],
          // },

          {
            label: "联系人",
            children: [
              {
                label: "机构联系人",
                placeholder: "机构联系人",
                display: false,
                search: true,
                searchSlot: true,
                prop: "contacts",
                slot: true,
                formatter: (row) => {
                  // return this._.map(row.contacts, "name").join("<br>");
                  console.log(
                    this._.get(row, "contacts", [])
                      .map((v) => v.name)
                      .join("<br> ")
                  );
                  return this._.get(row, "contacts", [])
                    .map((v) => v.name)
                    .join("<br> ");
                  return row.contacts[0] && row.contacts[0].name;
                },
              },
              {
                label: "手机号",
                display: false,
                // width: "180px",
                prop: "mobile",
                slot: true,
                formatter: (row) => {
                  return this._.get(row, "contacts", [])
                    .map((v) => v.mobile)
                    .join("<br/>");
                },
              },
            ],
          },

          {
            label: "负责人",
            search: true,
            type: "select",
            props: {
              label: "realname",
              value: "_id",
            },
            prop: "user",
            dicUrl: "users",
            dicQuery: {
              query: {
                limit: 0,
                where: {
                  role: 1,
                },
              },
            },
            searchFilterable: true,
            span: 8,
            slot: true,
            display: false,
          },

          {
            label: "今年累计合作(金额)",
            prop: "yearTotal",
            display: false,
            slot: true,
            sortable: true,
            width: "180px",
          },
          {
            label: "累计合作(金额)",
            prop: "total",
            display: false,
            slot: true,
            sortable: true,
            width: "180px",
          },
          {
            label: "未回款",
            prop: "remain",
            display: false,
            slot: true,
            sortable: true,
            width: "100px",
          },
          // {
          //   label: "客户类型",
          //   prop: "type",
          //   type: "radio",
          //   props: {
          //     label: "label",
          //     value: "label",
          //   },
          //   dicUrl: `dictionaries/type/customer.type`,
          //   hide: true,
          //   showColumn: false,
          // },
          // {
          //   label: "客户状态",
          //   prop: "state",
          //   type: "select",
          //   props: {
          //     label: "label",
          //     value: "label",
          //   },
          //   dicUrl: `dictionaries/type/customer.state`,
          //   hide: true,
          //   showColumn: false,
          // },

          {
            label: "客户来源",
            props: {
              label: "label",
              value: "label",
            },
            prop: "source",
            type: "select",
            rules: [
              {
                required: true,
                message: "请选择客户来源",
                trigger: "change",
              },
            ],
            dicUrl: `dictionaries/type/customer.source`,
            hide: true,
            showColumn: false,
            change: ({ value }) => {
              const referrerCol = this.option.column.find(
                (col) => col.prop === "referrer"
              );
              if (referrerCol) {
                if (value === "客户转介") {
                  referrerCol.display = true;
                } else {
                  referrerCol.display = false;
                  this.form.referrer = "";
                }
              }
            },
          },
          {
            label: "转介人",
            prop: "referrer",
            type: "input",
            display: false,
            clearable: true,
            maxlength: 50,
            hide: true,
            showColumn: false,
          },
          {
            label: "客户等级",
            search: true,
            prop: "grade",
            props: {
              label: "label",
              value: "label",
            },
            rules: [
              {
                required: true,
                message: "请选择客户等级",
                trigger: "change",
              },
            ],
            sortable: true,
            dicUrl: `dictionaries/type/customer.grade`,
            type: "radio",
            formslot: true,
            width: "100px",
            searchFilterable: true,
            // showColumn: false,
          },
          {
            label: "终端类型",
            prop: "business_scope",
            type: "select",
            props: {
              label: "label",
              value: "label",
            },
            rules: [
              {
                required: true,
                message: "请选择终端类型",
                trigger: "change",
              },
            ],
            multiple: true,
            filterable: true,
            clearable: true,
            dicUrl: `dictionaries/type/customer.business_scope`,
            dicFormatter: (res) => {
              this.buildBusinessScopeItemMap(res);
              return res;
            },
            // hide: true,
            slot: true,
            formslot: true,
            searchMultiple: true,
            search: true,
            searchLabelWidth: 100,

            // showColumn: false,
          },
          {
            label: "终端名称",
            prop: "business_scope_other_names",
            formslot: true,
            display: false,
            hide: true,
            showColumn: false,
            span: 24,
            rules: [],
          },
          // {
          //   label: "客户阶段",
          //   prop: "stage",
          //   type: "radio",
          //   props: {
          //     label: "label",
          //     value: "label",
          //   },
          //   dicUrl: `dictionaries/type/customer.stage`,
          //   hide: true,
          //   showColumn: false,
          // },
          // {
          //   label: "年份",
          //   prop: "search_year",
          //   display: false,
          //   showColumn: false,
          //   search: true,
          //   type: "year",
          //   hide: true,
          // },
          {
            label: "距上次联系天数",
            prop: "days_not_contacted",
            width: "180px",
            sortable: true,
            display: false,
          },
          {
            label: "距上次下单天数",
            prop: "days_without_order",
            width: "180px",
            sortable: true,
            display: false,
          },
          // {
          //   label: "历史负责人",
          //   search: true,
          //   type: "select",
          //   props: {
          //     label: "realname",
          //     value: "_id",
          //   },
          //   prop: "old_user",
          //   dicData: [],
          //   span: 8,
          //   slot: true,
          //   display: false,
          // },

          {
            label: "公司规模",
            prop: "companyScale",
            type: "select",
            dicData: [
              { label: "1-20", value: "1-20" },
              { label: "20-50", value: "20-50" },
              { label: "50-100", value: "50-100" },
              { label: "100以上", value: "100以上" },
            ],
            rules: [
              {
                required: true,
                message: "请选择公司规模",
                trigger: "blur",
              },
            ],
            span: 12,
            hide: true,
            showColumn: false,
          },
          {
            label: "是否有分支机构",
            prop: "hasBranch",
            type: "select",
            rules: [
              {
                required: true,
                message: "请选择是否有分支机构",
                trigger: "change",
              },
            ],
            dicData: [
              { label: "是", value: "是" },
              { label: "否", value: "否" },
            ],
            span: 12,
            hide: true,
            showColumn: false,
            change: ({ value }) => {
              const branchCol = this.option.column.find(
                (col) => col.prop === "branchProvinceCity"
              );
              if (branchCol) {
                if (value === "是") {
                  branchCol.display = true;
                } else {
                  branchCol.display = false;
                  this.form.branchProvinceCity = [];
                }
              }
            },
          },
          {
            label: "分支机构省市",
            prop: "branchProvinceCity",
            type: "cascader",
            filterable: true,
            multiple: true,
            popperClass: "hide-province-checkbox",
            checkStrictly: true,
            props: {
              label: "value",
              value: "value",
            },
            formatter: (row, value) => {
              if (!value) return "";
              if (Array.isArray(value) && value.length > 0 && Array.isArray(value[0])) {
                return value.map(v => v.join("-")).join("，");
              }
              return Array.isArray(value) ? value.join("-") : value;
            },
            dicUrl: "getCity",
            dicFormatter: (res) => {
              return (res.data || res).map(province => {
                const newProvince = { ...province };
                if (newProvince.children) {
                  newProvince.children = newProvince.children.map(city => {
                    const newCity = { ...city };
                    delete newCity.children; // Remove districts to keep only 2 levels
                    return newCity;
                  });
                }
                return newProvince;
              });
            },
            display: false,
            hide: true,
            showColumn: false,
            span: 12,
          },
          {
            label: "所属城市",
            prop: "region",
            type: "cascader",
            filterable: true,
            props: {
              label: "value",
              value: "value",
            },
            formatter: (row, value) => value && value.join("-"),
            // dicData:this.$store.state.cities,
            dicUrl: "getCity",
            checkStrictly: true,
            hide: true,
            showColumn: false,
          },
          {
            label: "深耕区域",
            prop: "deepTillArea",
            type: "select",
            rules: [
              {
                required: true,
                message: "请选择深耕区域",
                trigger: "change",
              },
            ],
            multiple: true,
            filterable: true,
            props: {
              label: "label",
              value: "value",
            },
            dicData: [
              { label: "全国", value: "全国" },
              { label: "北京市", value: "北京市" },
              { label: "天津市", value: "天津市" },
              { label: "河北省", value: "河北省" },
              { label: "山西省", value: "山西省" },
              { label: "内蒙古自治区", value: "内蒙古自治区" },
              { label: "辽宁省", value: "辽宁省" },
              { label: "吉林省", value: "吉林省" },
              { label: "黑龙江省", value: "黑龙江省" },
              { label: "上海市", value: "上海市" },
              { label: "江苏省", value: "江苏省" },
              { label: "浙江省", value: "浙江省" },
              { label: "安徽省", value: "安徽省" },
              { label: "福建省", value: "福建省" },
              { label: "江西省", value: "江西省" },
              { label: "山东省", value: "山东省" },
              { label: "河南省", value: "河南省" },
              { label: "湖北省", value: "湖北省" },
              { label: "湖南省", value: "湖南省" },
              { label: "广东省", value: "广东省" },
              { label: "广西壮族自治区", value: "广西壮族自治区" },
              { label: "海南省", value: "海南省" },
              { label: "重庆市", value: "重庆市" },
              { label: "四川省", value: "四川省" },
              { label: "贵州省", value: "贵州省" },
              { label: "云南省", value: "云南省" },
              { label: "西藏自治区", value: "西藏自治区" },
              { label: "陕西省", value: "陕西省" },
              { label: "甘肃省", value: "甘肃省" },
              { label: "青海省", value: "青海省" },
              { label: "宁夏回族自治区", value: "宁夏回族自治区" },
              { label: "新疆维吾尔自治区", value: "新疆维吾尔自治区" },
              { label: "台湾省", value: "台湾省" },
              { label: "香港特别行政区", value: "香港特别行政区" },
              { label: "澳门特别行政区", value: "澳门特别行政区" }
            ],
            formatter: (row, value) => {
              if (!value) return "";
              return Array.isArray(value) ? value.join("，") : value;
            },
            span: 12,
            hide: true,
            showColumn: false,
          },
          {
            label: "详细地址",
            prop: "address",
            rules: [
              {
                required: true,
                message: "请输入详细地址",
                trigger: "blur",
              },
            ],
            hide: true,
            showColumn: false,
          },
          {
            label: "年度合同",
            multiple: true,
            prop: "contractImg",
            type: "upload",
            dataType: "array",
            listType: "picture-card",
            accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
            action: "upload",
            span: 24,
            hide: true,
            showColumn: false,
          },
          {
            label: "年度合同时间",
            multiple: true,
            prop: "contractTimes",
            type: "daterange",
            span: 8,
            hide: true,
            showColumn: false,
          },
          {
            label: "年度合同附件",
            prop: "file",
            type: "upload",
            loadText: "附件上传中，请稍等",
            accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
            span: 18,
            hide: true,
            showColumn: false,
            action: "upload",
          },
          {
            label: "备注",
            prop: "info",
            type: "textarea",
            span: 24,
            hide: true,
            showColumn: false,
          },
          // {
          //   label: "导入联系人",
          //   type: "upload",
          //   loadText: "附件上传中，请稍等",
          //   span: 24,
          //   propsHttp: {
          //     res: "res",
          //   },
          //   // tip: "只能上传ex",
          //   action: "customers/import",
          // },
          // {
          //   label: "导入联系人",
          //   type: "import-button",
          // },
          {
            label: "添加联系人",
            prop: "contacts",
            type: "dynamic",
            hide: true,
            showColumn: false,
            span: 24,
            rules: [
              {
                required: true,
                message: "请添加联系人",
                trigger: "blur",
              },
            ],
            children: {
              column: [
                {
                  width: 200,
                  label: "排序",
                  prop: "reorder",
                  slot: true,
                },
                {
                  label: "姓名",
                  prop: "name",
                  placeholder: "机构联系人",
                  rules: [
                    {
                      required: true,
                      message: "请填写姓名",
                      trigger: "blur",
                    },
                  ],
                },
                {
                  label: "手机号",
                  prop: "mobile",
                  rules: [
                    {
                      required: true,
                      message: "请填写姓名",
                      trigger: "blur",
                    },
                  ],
                  rules: [{ validator: mobile, trigger: "blur", required: true }],
                },
                {
                  label: "备用手机号",
                  prop: "backupMobile",
                  value: "",
                  rules: [{ validator: backupMobileValidator, trigger: "blur" }],
                },
                {
                  label: "邮箱",
                  prop: "email",
                },
                {
                  label: "职务",
                  prop: "job",
                },
                {
                  label: "备注",
                  prop: "info",
                },
              ],
            },
          },
          {
            label: "开票管理",
            prop: "invoices",
            type: "dynamic",
            hide: true,
            showColumn: false,
            span: 24,
            children: {
              column: [
                {
                  label: "单位",
                  prop: "company",
                },
                {
                  label: "税号",
                  prop: "duty_paragraph",
                },
                // {
                //   label: "城市",
                //   prop: "city",
                //   type: "cascader",
                //   props: {
                //     label: "value",
                //     value: "value",
                //   },
                //   formatter: (row, value) => value && value.join("-"),
                //   dicUrl: "getCity",
                // },

                {
                  label: "手机号",
                  prop: "mobile",
                },
                {
                  label: "开户行",
                  prop: "bank",
                },
                {
                  label: "专票税率",
                  type: "number",
                  prop: "special_ticket",
                },
                {
                  label: "普票税率",
                  type: "number",
                  prop: "general_ticket",
                },
                {
                  label: "开户行账号",
                  prop: "account",
                },
                {
                  label: "详细地址",
                  prop: "address",
                  type: "textarea",
                },
              ],
            },
          },
          {
            label: "加入黑名单",
            prop: "isBlacklist",
            span: 24,
            type: "switch",
            props: {
              label: "label",
              value: "value",
            },
            dicData: [
              {
                label: "否",
                value: 0,
              },
              {
                label: "是",
                value: 1,
              },
            ],
            change: ({ value }) => {
              const reasonCol = this.option.column.find(
                (col) => col.prop === "blacklistReason"
              );
              if (reasonCol) {
                if (value === 1) {
                  reasonCol.display = true;
                  reasonCol.rules = [
                    {
                      required: true,
                      message: "请填写加入黑名单原因",
                      trigger: "blur",
                    },
                  ];
                } else {
                  reasonCol.display = false;
                  reasonCol.rules = [];
                  if (this.form) {
                    this.form.blacklistReason = "";
                  }
                }
              }
            },
            hide: true,
            showColumn: false,
          },
          {
            label: "加入黑名单原因",
            prop: "blacklistReason",
            type: "input",
            span: 24,
            display: false,
            hide: true,
            showColumn: false,
          },
          {
            label: "创建时间",
            prop: "createdAt",
            type: "date",
            display: true,
            disabled: true,
            sortable: true,
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
        ],
      },
      importData: [],
      exportotaltForm: {
        daterange: [],
        field: [],
      },
      dialogtotalExport: false,
    };
  },
  components: {
    CustomerChart,
  },
  computed: {
    isOneMonthTaskContext() {
      return this.user.role == 0 && Number(this.history_type) === 7;
    },
    isActivityTaskContext() {
      return this.user.role == 0 && Number(this.history_type) === 10;
    },
    activeTaskScene() {
      if (this.isActivityTaskContext) {
        return "activity";
      }
      if (this.isOneMonthTaskContext) {
        return "link";
      }
      return "";
    },
    showTaskActionButtons() {
      return !!this.activeTaskScene && this.taskActionSceneReady;
    },
    taskCreateButtonText() {
      return this.isActivityTaskContext ? "创建活动任务" : "创建建联任务";
    },
    taskProgressButtonText() {
      return this.isActivityTaskContext ? "活动任务进度" : "建联任务进度";
    },
    taskCreateDialogTitle() {
      return this.isActivityTaskContext ? "创建活动任务" : "创建建联任务";
    },
    taskCreateTypeLabel() {
      return this.isActivityTaskContext ? "活动任务" : "建联任务";
    },
    taskTypeValue() {
      return this.isActivityTaskContext ? "活动触达" : "客户建联";
    },
    taskDefaultContent() {
      return this.isActivityTaskContext ? "活动任务派发" : "";
    },
    taskContentLabel() {
      return this.isActivityTaskContext ? "活动任务" : "建联任务";
    },
    taskContentPlaceholder() {
      return this.isActivityTaskContext
        ? "请输入活动任务内容"
        : "请输入建联任务内容";
    },
    taskProgressDrawerTitle() {
      return this.isActivityTaskContext ? "活动任务进度" : "建联任务进度";
    },
    taskProgressReceiverLabel() {
      return this.isActivityTaskContext ? "负责人" : "接收人";
    },
    taskDetailDialogTitle() {
      return this.taskDetailType === "活动触达" ? "活动任务详情" : "建联任务详情";
    },
    selectedTaskCustomers() {
      return this.data.filter((item) => this.customerIds.includes(item._id));
    },
    selectedTaskPermissionError() {
      const invalidCustomer = this.selectedTaskCustomers.find((item) => item.isOperate === false);
      return invalidCustomer
        ? `您无权限对客户 ${invalidCustomer.name} 创建活动任务`
        : "";
    },
    taskReceivers() {
      return this.superintendents.filter((item) => item._id && item._id !== "空");
    },
    taskProgressPercent() {
      return this.taskProgressStats.total
        ? Math.round(
            (this.taskProgressStats.completed / this.taskProgressStats.total) * 100
          )
        : 0;
    },
    taskProgressColor() {
      if (this.taskProgressPercent >= 90) {
        return "#67c23a";
      }
      if (this.taskProgressPercent >= 60) {
        return "#e6a23c";
      }
      return "#f56c6c";
    },
    taskProgressEmptyText() {
      return this.isActivityTaskContext ? "近30天暂无活动任务" : "暂无建联任务";
    },
    businessScopeOtherTypes() {
      return this.getBusinessScopeOtherTypes(this.form.business_scope);
    },
    business_scope_name() {
      return (row) => {
        return Array.isArray(row.business_scope)
          ? row.business_scope.join(" | ")
          : row.business_scope;
      };
    },
    dialogOption() {
      return {
        translate: false,
        column: [
          {
            label: "负责人",
            prop: "user",
            filterable: true,
            props: {
              label: "realname",
              value: "_id",
            },
            type: "tree",
            multiple: true,
            rules: [
              {
                required: true,
                message: "请选择负责人",
                trigger: "blur",
              },
            ],
            span: 24,
            dicUrl: "users",
            dicQuery: {
              query: {
                limit: 0,
                where: {
                  role: 1,
                },
              },
            },
          },
        ],
      };
    },
    history() {
      if (!this.formRow || !this.formRow.history) {
        return [];
      }
      const rows = this.formRow.history.map((item, index) => {
        const baseId =
          item && item._id
            ? item._id
            : item && item.submitedAt
            ? item.submitedAt
            : "history";
        return {
          ...item,
          __historyKey: `${baseId}-${index}`,
        };
      });
      rows.sort((a, b) => {
        return Date.parse(b.submitedAt) - Date.parse(a.submitedAt);
      });
      return rows;
    },
  },

  watch: {
    "customerQuery.year"() {
      this.coData(this.obj);
      this.$message({
        message: `已为您切换至${this.dayjs(this.customerQuery.year).format(
          "YYYY"
        )}年数据`,
        type: "success",
        align: "center",
        center: true,
      });
    },
    sortOrder() {
      this.fetch();
    },
    grade() {
      this.fetch();
    },
    "form.name": {
      immediate: false,
      handler(value) {
        // this.isDay = true;
        // console.log(value);
      },
    },
    "$route.query.history_type"() {
      this.fetchCustomer();
    },
    "$route.query.customerId"(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!newVal && typeof this.query.where._id === 'string') {
          delete this.query.where._id;
        }
        this.fetchCustomer();
        if (!newVal && !this.$route.query.history_type) {
          this.fetch();
        }
      }
    },
    permission() {
      this.fetchCustomer();
    },
  },

  methods: {
    switchToBrokerView(brokerId) {
      this.viewMode = 'broker';
      this.brokerFilterId = brokerId || null;
      this.brokerPage.currentPage = 1;
      this.brokerSortOrder = -1;
      this.fetchBrokerData();
    },
    switchToCustomerView() {
      this.viewMode = 'customer';
    },
    async fetchBrokerData() {
      this.brokerLoading = true;
      try {
        const params = {
          page: this.brokerPage.currentPage,
          limit: this.brokerPage.pageSize,
          sortOrder: this.brokerSortOrder === -1 ? 'desc' : 'asc'
        };
        if (this.brokerFilterId) {
          params.user = this.brokerFilterId;
        }
        const res = await this.$http.get('customers/broker-statistics', { params });
        if (res && res.data) {
          this.brokerData = res.data.data || [];
          this.brokerPage.total = res.data.total || 0;
        }
      } catch (error) {
        console.error('Failed to fetch broker data:', error);
        this.$message.error('获取经纪人统计数据失败');
      } finally {
        this.brokerLoading = false;
      }
    },
    brokerSortChange(val) {
      if (val.prop === 'yearCooperationAmount') {
        this.brokerSortOrder = val.order === 'ascending' ? 1 : -1;
        this.brokerPage.currentPage = 1;
        this.fetchBrokerData();
      }
    },
    getBrokerAnalysisHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label && column.label.includes('V0')) return { backgroundColor: '#fdf5e6' };
      if (column.label && column.label.includes('V1')) return { backgroundColor: '#ffe4e1' };
      if (column.label && column.label.includes('V2')) return { backgroundColor: '#e0ffff' };
      if (column.label && column.label.includes('V3')) return { backgroundColor: '#e6e6fa' };
      if (column.label && column.label.includes('V4')) return { backgroundColor: '#98fb98' };
      if (column.label && column.label.includes('V5')) return { backgroundColor: '#ffff00' };
      if (column.label && column.label.includes('V6')) return { backgroundColor: '#ffa500' };
      return {};
    },
    openBrokerAnalysis(row) {
      this.currentBrokerId = row._id;

      const generateVTier = (prefix) => {
        const obj = {};
        const fields = ['count', 'month_deal', 'month_sales', 'year_deal', 'year_sales', 'month_new', 'month_new_sales', 'year_new', 'year_new_sales', 'month_contacted', 'month_uncontacted'];
        fields.forEach(f => {
          obj[`${prefix}_${f}`] = 0;
        });
        return obj;
      };

      this.brokerAnalysisData = [{
        brokerName: row.realname || row.group_name || '未知',
        v0_total: row.totalCustomerCount || 0,
        v0_year_deal: 0,
        v0_year_contacted: 0,
        v0_uncontacted_3m: row.notContact90DaysCount || 0,
        v0_undeal_12m: 0,
        v0_year_activated: 0,
        ...generateVTier('v1'),
        ...generateVTier('v2'),
        ...generateVTier('v3'),
        ...generateVTier('v4'),
        ...generateVTier('v5'),
        ...generateVTier('v6')
      }];
      this.showBrokerDrawer = true;
    },
    cloneCrudColumn(column) {
      const nextColumn = {
        ...column,
      };
      if (Array.isArray(column.children)) {
        nextColumn.children = column.children.map((child) => this.cloneCrudColumn(child));
      }
      return nextColumn;
    },
    getCrudColumnStateKey(column) {
      return column.prop || column.label;
    },
    ensureCrudColumnState() {
      if (this.defaultCrudColumnState.length) {
        return;
      }
      this.defaultCrudSelection = this.option.selection;
      this.defaultCrudMenuWidth = this.option.menuWidth;
      this.defaultCrudColumns = this.option.column.map((column) => this.cloneCrudColumn(column));
      this.defaultCrudColumnState = this.option.column.map((column) => {
        return {
          key: this.getCrudColumnStateKey(column),
          hide: column.hide,
          showColumn: column.showColumn,
        };
      });
    },
    refreshCrudTable() {
      if (!this.data.length) {
        return;
      }
      this.data = this.data.map((item) => {
        return {
          ...item,
        };
      });
      this.$forceUpdate();
      this.$nextTick(() => {
        const table = this.$refs.customerCrud && this.$refs.customerCrud.$refs.table;
        if (table && typeof table.doLayout === "function") {
          table.doLayout();
        }
      });
    },
    buildBlacklistModeColumns(columns, visibleProps) {
      return columns
        .filter((column) => visibleProps.has(column.prop))
        .map((column) => {
          const nextColumn = this.cloneCrudColumn(column);
          nextColumn.hide = false;
          nextColumn.showColumn = true;
          return nextColumn;
        });
    },
    applyBlacklistTableMode(enabled) {
      this.ensureCrudColumnState();
      if (this.isBlacklistTableMode === enabled) {
        this.refreshCrudTable();
        return;
      }
      const visibleProps = new Set(["name", "blacklistReason"]);
      const nextColumns = enabled
        ? this.buildBlacklistModeColumns(this.defaultCrudColumns, visibleProps)
        : this.defaultCrudColumns.map((column) => this.cloneCrudColumn(column));
      this.option = {
        ...this.option,
        selection: enabled ? false : this.defaultCrudSelection,
        menuWidth: enabled ? 180 : this.defaultCrudMenuWidth,
        column: nextColumns,
      };
      this.isBlacklistTableMode = enabled;
      this.crudRenderKey += 1;
      this.refreshCrudTable();
    },
    getStatHistoryType(item) {
      if (!item || !item.to) {
        return null;
      }
      const queryString = item.to.split("?")[1] || "";
      const searchParams = new URLSearchParams(queryString);
      const historyType = Number(searchParams.get("history_type"));
      return Number.isNaN(historyType) ? null : historyType;
    },
    openBlacklistView(row, index) {
      if (this.$refs.customerCrud && typeof this.$refs.customerCrud.rowView === "function") {
        this.$refs.customerCrud.rowView(row, index);
      }
    },
    openBlacklistEdit(row, index) {
      if (this.$refs.customerCrud && typeof this.$refs.customerCrud.rowEdit === "function") {
        this.$refs.customerCrud.rowEdit(row, index);
      }
    },
    getDefaultTaskProgressFilter() {
      if (this.isActivityTaskContext) {
        return {
          daterange: [
            dayjs().subtract(30, "day").startOf("day").valueOf(),
            dayjs().endOf("day").valueOf(),
          ],
          receiverId: "",
          status: "all",
          page: 1,
          limit: 10,
        };
      }
      return {
        daterange: [],
        receiverId: "",
        status: "all",
        page: 1,
        limit: 10,
      };
    },
    getTaskCreateEndpoint() {
      return this.isActivityTaskContext ? "task/create" : "customer-link-tasks/batch-create";
    },
    getTaskProgressEndpoint() {
      return this.isActivityTaskContext ? "task/progress" : "customer-link-tasks/progress";
    },
    getTaskListEndpoint() {
      return this.isActivityTaskContext ? "task/progress" : "customer-link-tasks";
    },
    getTaskDetailEndpoint(taskType) {
      return taskType === "活动触达" ? "task" : "customer-link-tasks";
    },
    syncTaskActionSceneReady() {
      this.taskActionSceneReady = !!this.activeTaskScene;
    },
    normalizeTaskCreateResult(data = {}) {
      const customerSuccessList = Array.isArray(data.customerSuccessList)
        ? data.customerSuccessList
        : [];
      const customerFailList = Array.isArray(data.customerFailList) ? data.customerFailList : [];
      return {
        ...data,
        taskId: data.taskId || _.get(customerSuccessList, "[0].taskId", ""),
        successCount:
          data.successCount !== undefined ? data.successCount : customerSuccessList.length,
        failCount: data.failCount !== undefined ? data.failCount : customerFailList.length,
        failures: data.failures || customerFailList,
        customerSuccessList,
        customerFailList,
      };
    },
    async fetchLinkTaskTypeOptions() {
      if (this.isActivityTaskContext) return;
      try {
        const res = await this.$http.get("dictionaries/type/" + encodeURIComponent("建联任务类型"));
        this.linkTaskTypeOptions = res.data || res || [];
      } catch (e) {
        this.linkTaskTypeOptions = [];
        console.error("获取任务类型字典失败", e);
      }
    },
    resetTaskCreateState() {
      this.taskCreateResult = null;
      this.taskSubmitting = false;
      this.taskForm = {
        content: this.taskDefaultContent,
        plannedAt: dayjs().add(72, "hour").valueOf(),
        assignToOwner: true,
        receiverId: "",
        taskType: this.linkTaskTypeOptions.length ? this.linkTaskTypeOptions[0].label : "",
      };
      this.$nextTick(() => {
        this.$refs.taskForm && this.$refs.taskForm.clearValidate();
      });
    },
    async openCreateTaskDialog() {
      if (!this.customerIds.length) {
        this.$message.error("请先选择客户");
        return;
      }
      if (this.isActivityTaskContext && this.selectedTaskPermissionError) {
        this.$message.error(this.selectedTaskPermissionError);
        return;
      }
      if (!this.isActivityTaskContext) {
        await this.fetchLinkTaskTypeOptions();
      }
      this.taskCreateDialog = true;
      this.resetTaskCreateState();
    },
    async submitTaskCreate() {
      this.$refs.taskForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        if (!dayjs(this.taskForm.plannedAt).isAfter(dayjs())) {
          this.$message.error("计划完成时间必须晚于当前时间");
          return false;
        }
        if (this.isActivityTaskContext && this.selectedTaskPermissionError) {
          this.$message.error(this.selectedTaskPermissionError);
          return false;
        }
        this.taskSubmitting = true;
        try {
          const payload = {
            customerIds: this.customerIds,
            content: this.taskForm.content,
            plannedAt: this.taskForm.plannedAt,
            assignToOwner: this.taskForm.assignToOwner,
            receiverId: this.taskForm.assignToOwner ? "" : this.taskForm.receiverId,
            taskType: this.isActivityTaskContext ? "活动触达" : this.taskForm.taskType,
          };
          const { data } = await this.$http.post(this.getTaskCreateEndpoint(), payload);
          this.taskCreateResult = this.normalizeTaskCreateResult(data);
          if (this.isActivityTaskContext) {
            this.$notify({
              title: "成功",
              message: `活动任务创建成功，已派发 ${this.taskCreateResult.successCount} 条`,
              type: "success",
            });
          } else {
            this.$message.success(
              `创建完成，成功 ${this.taskCreateResult.successCount} 条，失败 ${this.taskCreateResult.failCount} 条`
            );
          }
          await this.fetch();
          this.refreshTaskProgress();
        } finally {
          this.taskSubmitting = false;
        }
      });
    },
    buildTaskProgressParams() {
      const params = {
        page: this.taskProgressFilter.page,
        limit: this.taskProgressFilter.limit,
        status: this.taskProgressFilter.status,
      };
      if (this.taskProgressFilter.receiverId) {
        params.receiverId = this.taskProgressFilter.receiverId;
      }
      if (this.taskProgressFilter.daterange.length === 2) {
        params.startAt = this.taskProgressFilter.daterange[0];
        params.endAt = this.taskProgressFilter.daterange[1];
      }
      if (this.isActivityTaskContext) {
        params.taskType = "活动触达";
        params.dateField = "createdAt";
        params.sortField = "createdAt";
        params.sortOrder = "desc";
      }
      return params;
    },
    async fetchTaskProgressStats() {
      const { data } = await this.$http.get(this.getTaskProgressEndpoint(), {
        params: this.buildTaskProgressParams(),
      });
      this.taskProgressStats = {
        total: data.total || 0,
        completed: data.completed || 0,
        processing: data.processing || 0,
        overdue: data.overdue || 0,
      };
      if (this.isActivityTaskContext) {
        this.taskProgressList = data.list || [];
        this.taskProgressTotal = data.total || 0;
      }
    },
    async fetchTaskProgressList() {
      if (this.isActivityTaskContext) {
        return;
      }
      const { data } = await this.$http.get(this.getTaskListEndpoint(), {
        params: this.buildTaskProgressParams(),
      });
      this.taskProgressList = data.data || [];
      this.taskProgressTotal = data.total || 0;
    },
    async refreshTaskProgress() {
      if (!this.showTaskActionButtons) {
        return;
      }
      this.taskProgressLoading = true;
      try {
        await Promise.all([this.fetchTaskProgressStats(), this.fetchTaskProgressList()]);
      } finally {
        this.taskProgressLoading = false;
      }
    },
    startTaskProgressTimer() {
      this.stopTaskProgressTimer();
      this.taskProgressTimer = setInterval(() => {
        if (this.taskProgressDrawer) {
          this.refreshTaskProgress();
        }
      }, 30000);
    },
    stopTaskProgressTimer() {
      if (this.taskProgressTimer) {
        clearInterval(this.taskProgressTimer);
        this.taskProgressTimer = null;
      }
    },
    openTaskProgressDrawer() {
      this.taskProgressDrawer = true;
      this.taskProgressFilter = {
        ...this.getDefaultTaskProgressFilter(),
        page: 1,
      };
      this.refreshTaskProgress();
      this.startTaskProgressTimer();
    },
    resetTaskProgressFilter() {
      this.taskProgressFilter = this.getDefaultTaskProgressFilter();
      this.refreshTaskProgress();
    },
    changeTaskStatusFilter(status) {
      this.taskProgressFilter.status = status;
      this.taskProgressFilter.page = 1;
      this.refreshTaskProgress();
    },
    taskStatusText(status, isOverdue) {
      if (status === "completed") {
        return "已完成";
      }
      if (isOverdue) {
        return "已逾期";
      }
      return {
        pending: "待处理",
        processing: "进行中",
      }[status] || "待处理";
    },
    taskStatusTag(row) {
      if (row.status === "completed") {
        return "success";
      }
      if (row.isOverdue) {
        return "danger";
      }
      if (row.status === "processing") {
        return "warning";
      }
      return "info";
    },
    taskRowCompletionRate(row) {
      if (!row) {
        return 0;
      }
      if (row.status === "completed") {
        return 100;
      }
      if (row.status === "processing") {
        return 50;
      }
      return 0;
    },
    async openTaskDetail(row) {
      this.taskDetailDialog = true;
      this.taskDetailLoading = true;
      try {
        const taskId = row._id || row;
        const taskType = row.type || this.taskTypeValue;
        const { data } = await this.$http.get(
          `${this.getTaskDetailEndpoint(taskType)}/${taskId}`
        );
        this.taskDetailType = data.type || taskType;
        this.taskDetail = data;
      } finally {
        this.taskDetailLoading = false;
      }
    },
    handleTaskRealtime() {
      if (this.taskProgressDrawer) {
        this.refreshTaskProgress();
      }
    },
    watchTotal(row) {
      if (!row.year) {
        return false;
      }
      this.$router.push(
        `/schedules/list?customerId=${row.customer}&new=true&totalYear=${row.year}`
      );
    },
    batchModify() {
      if (this.customerIds.length > 0) {
        this.dialogAssigningUser = true;
      } else {
        this.$message.error("请先批量选择客户");
      }
    },
    async assigningSubmit(row, done) {
      await this.$http.post(`customers/batchModify_user`, {
        ids: this.customerIds,
        users: row.user,
      });
      this.$message.success("批量分配成功");
      this.fetch();
      done();
      this.dialogAssigningUser = false;
      setTimeout(() => {
        this.assigningUser = [];
      }, 500);
    },
    async editRow() {
      if (this.customerIds.length > 0) {
        try {
          await this.$confirm("是否确认批量解除负责人？");
        } catch (e) {
          return;
        }
        await this.$http.post(`customers/secure_user`, this.customerIds);
        this.$message.success("解除成功");
        this.fetch();
      } else {
        this.$message.error("请先批量选择客户");
      }
    },
    selectionChange(list) {
      this.customerIds = list.map((v) => {
        return v._id;
      });
      // console.log(this.customerIds);
      // this.$message.success("选中的数据" + JSON.stringify(list));
    },
    handleCurrentChange(val) {
      this.customerQuery.page = val;
      this.coData(this.obj);
    },
    async initChart1() {
      let chartDom = this.$refs.chart1;
      let chartDom2 = this.$refs.chart2;
      let myChart = this.$echarts.init(chartDom);

      myChart.setOption(this.monthlySalesChart, true);
      let myChart2;
      if (chartDom2) {
        myChart2 = this.$echarts.init(chartDom2);
      }
      myChart2 && myChart2.setOption(this.monthlyImplementationChart, true);

      window.addEventListener("resize", function () {
        myChart.resize();
        myChart2 && myChart2.resize();
      });
    },
    async coData(row) {
      this.obj = row;
      this.dialogData = true;
      this.coiLoading = true;
      const res = await this.$http.post(`customers/customerData/${row._id}`, {
        params: {
          query: JSON.stringify(this.customerQuery),
        },
      });
      this.coiLoading = false;
      this.customerPage.total = res.data.total;
      this.customers = res.data.cooperativeCustomers;
      this.monthlySalesChart = res.data.monthlySalesChart;
      this.monthlyImplementationChart = res.data.monthlyImplementationChart;
      this.customerOption = res.data.customerOption;
      this.hascustomer = res.data.hascustomer;

      this.customerOption.data.map((v) => {
        if (v.to) {
          v.click = () => this.fetchWhere(v.to);
        }
      });
      // this.coach = res.data.coach;
      // console.log(res.data.teachingDays)
      this.$nextTick(() => {
        this.initChart1();
      });
    },
    fetchWhere(to) {
      this.customerQuery.where.type = to;
      this.coData(this.obj);
      // console.log(this.customerQuery)
    },
    async sortChange(e) {
      const { order, prop } = e;
      this.query.sort = {
        [prop]: order == "ascending" ? 1 : -1,
      };
      // this.query.sort[prop] = order == "ascending" ? 1 : -1;
      this.$nextTick(() => {
        this.fetch();
      });
    },
    followUpType(val) {
      let type = null;
      if (val == "daily") {
        type = "日常业务对接";
      } else if (val == "keyPoint") {
        type = "重点业务机会";
      }
      return type;
    },
    async exportSubmit(row, done) {
      const res = await this.$http.post(
        "/customers/exportCustomer/",
        {
          ...row,
          history_type: this.history_type,
        },
        {
          responseType: "arraybuffer",
        }
      );
      const link = document.createElement("a");
      let blob = new Blob([res.data], { type: "application/x-xls" });
      link.href = URL.createObjectURL(blob);
      const title = `客户数据-${dayjs().format("YYYY-MM-DD")}`;
      link.download = `${title}.xlsx`;
      link.click();
      document.body.appendChild(link);
      done();
    },

    async exportTotalSubmit(row, done) {
      const res = await this.$http.post(
        "/customers/exportCustomertotal/",
        {
          ...row,
          history_type: this.history_type,
        },
        {
          responseType: "arraybuffer",
        }
      );
      const link = document.createElement("a");
      let blob = new Blob([res.data], { type: "application/x-xls" });
      link.href = URL.createObjectURL(blob);
      const title = `客户累计金额数据-${dayjs().format("YYYY-MM-DD")}`;
      link.download = `${title}.xlsx`;
      link.click();
      document.body.appendChild(link);
      done();
    },

    async exportSubmitR(row, done) {
      const res = await this.$http.post(
        "/customers/exportCustomerR/",
        {
          ...row,
          history_type: this.history_type,
        },
        {
          responseType: "arraybuffer",
        }
      );
      const link = document.createElement("a");
      let blob = new Blob([res.data], { type: "application/x-xls" });
      link.href = URL.createObjectURL(blob);
      const title = `蓄水池客户数据-${dayjs().format("YYYY-MM-DD")}`;
      link.download = `${title}.xlsx`;
      link.click();
      document.body.appendChild(link);
      done();
      this.showRreservoir = false;
      this.$message.success("导出成功");
    },
    exportCustomer() {
      const startMonth = dayjs(this.value).startOf("year").toDate();
      const endMonth = dayjs(this.value).endOf("year").toDate();
      this.$set(this.exportForm.daterange, 0, startMonth);
      this.$set(this.exportForm.daterange, 1, endMonth);
      this.dialogExport = true;
    },

    exportCustomertotal() {
      const startMonth = dayjs(this.value).startOf("year").toDate();
      const endMonth = dayjs(this.value).endOf("year").toDate();
      this.$set(this.exportotaltForm.daterange, 0, startMonth);
      this.$set(this.exportotaltForm.daterange, 1, endMonth);
      this.dialogtotalExport = true;
    },

    exportRereservoir() {
      const startMonth = dayjs(this.value).startOf("year").toDate();
      const endMonth = dayjs(this.value).endOf("year").toDate();
      this.$set(this.reservoirFrom.daterange, 0, startMonth);
      this.$set(this.reservoirFrom.daterange, 1, endMonth);
      this.showRreservoir = true;
    },

    showRreservoirhandleClose() {
      this.showRreservoir = false;
    },

    // async exprot() {
    //   await this.$http.post("customers/export", {});
    // },

    preview(file, column, done) {
      const ext = file.url.split(".").pop();
      if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
        done();
      } else {
        window.open(file.url);
      }
    },
    rowCell(row, index) {
      console.log(row, index);
    },
    getBusinessScopePresetTypes() {
      return [
        "非储国有行【工农中建交】",
        "非储国有行",
        "国有行",
        "邮政邮储",
        "股份行【招商、中信、兴业、广发、民生、平安、光大、浦发、华夏、浙商、渤海、恒丰】",
        "股份行",
      ];
    },
    getBusinessScopeOtherTypes(scopes) {
      const list = Array.isArray(scopes) ? scopes : [];
      const presetTypes = this.getBusinessScopePresetTypes();
      return list.filter((item) => item && !presetTypes.includes(item));
    },
    buildBusinessScopeItemMap(items) {
      const list = Array.isArray(items) ? items : (items && items.data ? items.data : []);
      const map = {};
      list.forEach((item) => {
        const key = item.label || item.value;
        if (key) {
          map[key] = { _id: item._id, label: item.label, value: item.value, childrenCount: item.childrenCount || 0 };
        }
      });
      this.businessScopeItemMap = map;
      // 延迟加载已选中类型的子项（编辑模式下，dicFormatter 可能在 beforeOpen 之后才执行）
      this.$nextTick(() => {
        const selected = this.form && this.form.business_scope;
        if (selected && Array.isArray(selected) && selected.length) {
          this.loadAllBusinessScopeChildren(this.getBusinessScopeOtherTypes(selected));
        }
      });
    },
    hasBusinessScopeChildren(type) {
      const children = this.businessScopeChildrenForType(type);
      return children.length > 0;
    },
    businessScopeChildrenForType(type) {
      return this.businessScopeChildrenMap[type] || [];
    },
    async loadBusinessScopeChildren(type) {
      const item = this.businessScopeItemMap[type];
      if (!item || !item._id) return;
      if (this.businessScopeChildrenMap[type]) return;
      try {
        const res = await this.$http.get("dict-items/option", { params: { dictId: item._id } });
        this.$set(this.businessScopeChildrenMap, type, res.data || res || []);
      } catch (e) {
        console.error("Failed to load business scope children for", type, e);
        this.$set(this.businessScopeChildrenMap, type, []);
      }
    },
    async loadAllBusinessScopeChildren(types) {
      for (const type of types) {
        await this.loadBusinessScopeChildren(type);
      }
    },
    getBusinessScopeOtherNamesColumn() {
      return this.option.column.find((col) => col.prop === "business_scope_other_names");
    },
    getCustomerCrudDialogForm() {
      return this.$refs.customerCrud && this.$refs.customerCrud.$refs
        ? this.$refs.customerCrud.$refs.dialogForm
        : null;
    },
    validateBusinessScopeOtherNamesRule(rule, value, callback) {
      const scopes = this.form && this.form.business_scope;
      const otherTypes = this.getBusinessScopeOtherTypes(scopes);
      if (!otherTypes.length) {
        callback();
        return;
      }
      const normalized = this.normalizeBusinessScopeOtherNames(scopes, value);
      for (const type of otherTypes) {
        const name = normalized[type];
        if (!name) {
          callback(new Error(`请填写“${type}”的终端名称`));
          return;
        }
        if (name.length > 1000) {
          callback(new Error(`”${type}”终端名称长度不能超过1000个字符`));
          return;
        }
      }
      callback();
    },
    buildBusinessScopeOtherNamesRules() {
      return [
        {
          required: true,
          validator: this.validateBusinessScopeOtherNamesRule,
          trigger: "change",
        },
        {
          required: true,
          validator: this.validateBusinessScopeOtherNamesRule,
          trigger: "blur",
        },
      ];
    },
    syncBusinessScopeOtherNamesColumn(otherTypes) {
      const otherNamesCol = this.getBusinessScopeOtherNamesColumn();
      if (!otherNamesCol) {
        return;
      }
      const shouldDisplay = otherTypes.length > 0;
      otherNamesCol.display = shouldDisplay;
      otherNamesCol.rules = shouldDisplay
        ? this.buildBusinessScopeOtherNamesRules()
        : [];
      this.$nextTick(() => {
        const dialogForm = this.getCustomerCrudDialogForm();
        if (!dialogForm || typeof dialogForm.clearValidate !== "function") {
          return;
        }
        dialogForm.clearValidate("business_scope_other_names");
      });
    },
    async syncBusinessScopeOtherNames(scopes) {
      const otherTypes = this.getBusinessScopeOtherTypes(scopes);
      const currentMap =
        this.form.business_scope_other_names &&
        typeof this.form.business_scope_other_names === "object"
          ? this.form.business_scope_other_names
          : {};
      const nextMap = {};
      otherTypes.forEach((type) => {
        const currentValue = currentMap[type];
        nextMap[type] = typeof currentValue === "string" ? currentValue : "";
      });
      this.$set(this.form, "business_scope_other_names", nextMap);
      this.syncBusinessScopeOtherNamesColumn(otherTypes);
      await this.loadAllBusinessScopeChildren(otherTypes);
    },
    handleBusinessScopeChildSelect(type) {
      this.$nextTick(() => {
        this.handleBusinessScopeOtherNamesInput();
      });
    },
    handleBusinessScopeCascaderChange(value) {
      if (!Array.isArray(value)) {
        value = [];
      }
      const scopes = [];
      const otherNames = {};
      for (const path of value) {
        if (!path || !path.length) continue;
        const parent = path[0];
        const child = path.length > 1 ? path[1] : null;
        if (parent && !scopes.includes(parent)) {
          scopes.push(parent);
        }
        if (parent && child) {
          otherNames[parent] = child;
        }
      }
      const currentOtherNames = this.form.business_scope_other_names || {};
      for (const type of scopes) {
        if (!otherNames[type] && currentOtherNames[type]) {
          otherNames[type] = currentOtherNames[type];
        }
      }
      this.$set(this.form, "business_scope", scopes);
      this.$set(this.form, "business_scope_other_names", otherNames);
      this.syncBusinessScopeOtherNames(scopes);
    },
    async buildCascaderTree() {
      if (!Object.keys(this.businessScopeItemMap).length) {
        try {
          const res = await this.$http.get("dictionaries/type/customer.business_scope");
          this.buildBusinessScopeItemMap(res.data || res);
        } catch (e) {
          console.error("Failed to fetch business scope dict", e);
          return;
        }
      }
      const tree = [];
      for (const key of Object.keys(this.businessScopeItemMap)) {
        const item = this.businessScopeItemMap[key];
        const node = { label: item.label, value: item.label, children: [] };
        if (item.childrenCount > 0) {
          if (!this.businessScopeChildrenMap[item.label] || !this.businessScopeChildrenMap[item.label].length) {
            try {
              const res = await this.$http.get("dict-items/option", { params: { dictId: item._id } });
              this.$set(this.businessScopeChildrenMap, item.label, res.data || res || []);
            } catch (e) {
              this.$set(this.businessScopeChildrenMap, item.label, []);
            }
          }
          node.children = (this.businessScopeChildrenMap[item.label] || []).map((c) => ({
            label: c.name,
            value: c.name,
          }));
        }
        tree.push(node);
      }
      this.cascaderBusinessScopeOptions = tree;
    },
    rebuildCascaderValue() {
      const scopes = this.form.business_scope || [];
      const otherNames = this.form.business_scope_other_names || {};
      const cascaderValue = [];
      for (const scope of scopes) {
        if (otherNames[scope]) {
          cascaderValue.push([scope, otherNames[scope]]);
        } else {
          cascaderValue.push([scope]);
        }
      }
      this.cascaderBusinessScope = cascaderValue;
    },
    handleBusinessScopeOtherNamesInput() {
      this.$nextTick(() => {
        const dialogForm = this.getCustomerCrudDialogForm();
        if (!dialogForm || typeof dialogForm.validateField !== "function") {
          return;
        }
        dialogForm.validateField("business_scope_other_names");
      });
    },
    normalizeBusinessScopeOtherNames(scopes, value) {
      const otherTypes = this.getBusinessScopeOtherTypes(scopes);
      const source = value && typeof value === "object" ? value : {};
      const normalized = {};
      otherTypes.forEach((type) => {
        const name = source[type];
        normalized[type] = typeof name === "string" ? name.trim() : "";
      });
      return normalized;
    },
    validateBusinessScopeOtherNames(row) {
      const otherTypes = this.getBusinessScopeOtherTypes(row.business_scope);
      row.business_scope_other_names = this.normalizeBusinessScopeOtherNames(
        row.business_scope,
        row.business_scope_other_names
      );
      if (!otherTypes.length) {
        return true;
      }
      for (const type of otherTypes) {
        const name = row.business_scope_other_names[type];
        if (!name) {
          this.$message.error(`请填写“${type}”的终端名称`);
          return false;
        }
        if (name.length > 1000) {
          this.$message.error(`”${type}”终端名称长度不能超过1000个字符`);
          return false;
        }
      }
      return true;
    },
    normalizeDeepTillArea(value) {
      if (Array.isArray(value)) {
        return value.filter((item) => typeof item === "string" && item);
      }
      if (typeof value === "string" && value) {
        return [value];
      }
      return [];
    },
    async beforeOpen(done, type) {
      if (this.form.isOperate == false && this.user.role !== 0) {
        //this.$message.error("您无权限操作");
        //return;
      }
      if (["add", "edit"].includes(type)) {
        this.$set(
          this.form,
          "deepTillArea",
          this.normalizeDeepTillArea(this.form.deepTillArea)
        );
        // 确保 business_scope_other_names 被初始化
        if (!this.form.business_scope_other_names || typeof this.form.business_scope_other_names !== 'object') {
          this.$set(this.form, "business_scope_other_names", {});
        }
        const field = this.option.column.find((v) => v.prop === "name");
        // field.type = "text";
        const referrerCol = this.option.column.find(
          (v) => v.prop === "referrer"
        );
        if (referrerCol) {
          if (this.form.source === "客户转介") {
            referrerCol.display = true;
          } else {
            referrerCol.display = false;
          }
        }
        const branchCol = this.option.column.find(
          (v) => v.prop === "branchProvinceCity"
        );
        if (branchCol) {
          if (this.form.hasBranch === "是") {
            branchCol.display = true;
          } else {
            branchCol.display = false;
          }
        }
        // 重置子项缓存，避免上次打开遗留的脏数据
        this.businessScopeChildrenMap = {};
        this.syncBusinessScopeOtherNames(this.form.business_scope);
        // 构建级联树并重建选中值
        await this.buildCascaderTree();
        this.rebuildCascaderValue();
      }
      done();
    },

    afterClose(done, type) {
      const field = this.option.column.find((v) => v.prop === "name");
      field.type = "";
      done();
    },
    async submit(row, done) {
      this.$clear(this.obj);

      await this.$http.put(`customers/${this.obj._id}`, this.obj);
      this.$message.success("提交成功");
      this.fetch();
      done();
      this.dialogPrincipal = false;
      setTimeout(() => {
        this.obj.user = [];
      }, 500);
    },

    closeAssigningUser(done) {
      done();
      setTimeout(() => {
        this.assigningUser = [];
      }, 500);
    },

    handleClose(done) {
      done();
      setTimeout(() => {
        this.obj.user = [];
        this.assigningUser = [];
      }, 500);
    },
    handleCloseTotal(done) {
      done();
      this.dialogtotalExport = false;
    },
    dataClose(done) {
      done();
    },

    distribution(scope) {
      if (scope.row.user) {
        let old_user = scope.row.old_user || [];
        old_user = old_user.concat(scope.row.user || []);
        old_user = Array.from(new Set(old_user));
        this.obj.old_user = old_user;
        const users = scope.row.user.map((v) => {
          return v._id;
        });
        this.obj.user = users;
      }

      this.obj._id = scope.row._id;
      this.dialogPrincipal = true;
    },
    async screen() {
      const res = await this.$http.get("customers/unsettled");
      this.ids = { _id: { $nin: res.data.ids }, isBlacklist: 0 };
      this.fetch(this.ids);
    },
    handleGet() {
      window.open("/cdn/demo.xlsx");
    },
    async doImportFollowUp() {
      if (this.importData.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "导入中，请稍后。请勿关闭刷新页面",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        await this.$http.post("customers/follow_up/import", this.importData);
        loading.close();
        this.fetch();
        this.$message.success("导入成功");
      } else {
        this.$message.error("上传文件为空");
      }
    },
    async parseFile(e) {
      const file = e.target.files[0];
      const { results } = await this.$Export.xlsx(file);
      const items = results.map((v) => {
        return {
          name: v["客户名称"],
          history: [
            {
              contact: v["联系人"],
              contact_way: v["沟通方式"],
              time: v["跟进日期"],
              content: v["沟通内容"],
            },
          ],
        };
      });
      this.$message.success("上传成功,请导入");
      this.importData = items;
    },
    async doImport() {
      if (this.importData.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "导入中，请稍后。请勿关闭刷新页面",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        await this.$http.post("customers/import", this.importData);
        loading.close();
        this.fetch();
        this.$message.success("导入成功");
      } else {
        this.$message.error("上传文件为空");
      }
    },
    openTotal(row) {
      this.showTotalQuery.customer = row;
      if (!this.showTotalQuery.customer) {
        return this.$message.error("客户id不能为空");
      }
      this.showTotal = true;

      this.fetchTotal();
    },
    async fetchTotal() {
      const { data } = await this.$http.get("customers/total/list", {
        params: {
          customer: this.showTotalQuery.customer._id,
          year: this.query.where.search_year,
        },
      });
      this.totalData = data;
      this.totalAmount = data.reduce((total, cur) => {
        return (total += cur.total);
      }, 0);
    },
    closeTotal() {
      this.showTotal = false;
      this.showTotalQuery.customer = "";
    },
    async parseItems(e) {
      const file = e.target.files[0];
      const { results } = await this.$Export.xlsx(file);
      const items = results.map((v) => {
        return {
          name: v["客户名称"],
          contacts: [
            {
              name: v["联系人姓名"],
              mobile: v["联系人电话"],
              email: v["联系人邮箱"],
              job: v["联系人职务"],
              info: v["联系人备注"],
            },
          ],
          region: v["所属城市"],
          address: v["详细地址"],
          state: v["客户状态"],
          stage: v["客户阶段"],
          type: v["客户类型"],
          grade: v["客户等级"],
          source: v["客户来源"],
          info: v["备注"],
          user: v["负责人"],
        };
      });
      this.$message.success("上传成功,请导入");
      this.importData = items;
      // const items = [];
      // results.slice(10, 15).map((v) => {
      //   const [
      //     客户名称,
      //     联系人姓名,
      //     联系人电话,
      //     联系人邮箱,
      //     联系人备注,
      //     所属城市,
      //     详细地址,
      //   ] = Object.values(v);
      //   const item = {
      //     name: 客户名称,
      //     contacts: [
      //       {
      //         name: 联系人姓名,
      //         mobile: 联系人电话,
      //         email: 联系人邮箱,
      //         info: 联系人备注,
      //       },
      //     ],
      //     region: [所属城市],
      //     address: 详细地址,
      //   };
      //   items.push(item);
      // });
    },

    // uploadAfter(res, done, loading) {
    //   this.customerId = res._id;
    //   let contacts = this.findObject(this.option.column, "contacts");

    //   // let column= contacts.children.column
    //   // column.forEach(v=>{
    //   //   column.push(v)
    //   // })
    //   // this.form.contacts = res.contacts;
    //   done();
    //   // console.log(contacts);
    // },
    async fetchCustomers(q) {
      const res = await this.$http.get("customers/option/name", {
        params: {
          name: q,
        },
      });
      return res.data;
    },
    async fetchContactsAsync(q) {
      const res = await this.$http.get("customers/option/contact", {
        params: {
          name: q,
        },
      });
      return res.data;
    },
    async queryContactAsync(queryString, cb) {
      const data = await this.fetchContactsAsync(queryString);
      cb(data);
    },
    async querySearchAsync(queryString, cb) {
      const data = await this.fetchCustomers(queryString);
      cb(data);
    },
    handleSelect(item) {
      this.searchCustomerId = item._id;
      this.selectedItemName = item.value;
    },
    handleInputChange(val) {
      if (this.searchCustomerId && val === this.selectedItemName) {
        return;
      }
      this.searchCustomerId = null;
      this.selectedItemName = null;
    },
    handleClear() {
      this.searchCustomerId = null;
      this.selectedItemName = null;
    },
    handleContactSelect(item) {
      // optional handling when contact is selected
      // Currently we can just use name search
    },
    handleContactInputChange(val) {
      // optional handling when contact input changes
    },
    handleContactClear() {
      // optional handling when contact is cleared
    },
    async search(where, done) {
      if (where.user && where.user !== "空") {
        try {
          await this.$confirm("是否切换到经纪人统计视图？", "提示", {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "info"
          });
          done();
          this.switchToBrokerView(where.user);
          return;
        } catch (e) {
          // User clicked "No", continue normal search
        }
      }

      done();
      if (where.contacts) {
        where[`contacts.name`] = { $regex: where.contacts };
        delete where.contacts;
      }
      // Clean up ID search to force name-based search as requested
      this.searchCustomerId = null;
      
      if (where.name) {
        const nameVal = where.name;
        where.name = { $regex: nameVal };
        // Ensure this.where is set correctly for fetchTime to extract the regex object
        // fetchTime reads this.where.$regex, so we nest the regex object
        this.where = { $regex: { $regex: nameVal } };
      } else {
        this.where = null;
      }
      if (where.grade) {
        where.grade = { $regex: where.grade };
        this.grade = where.grade;
      }
      if (where.user) {
        where.user = where.user;
        // this.grade = where.grade;
        this.wname = where.user;
      }
      if (where.user == "空") {
        where.user = [];
      }
      where.isBlacklist = 0;
      if (this.user.role !== 0) {
        if (!where.name && !where.user && !where.grade && !where.business_scope) {
          if (this.permission == "me") {
            if (this.user.role == 5) {
              where.user = {
                $in: 5,
              };
            } else {
              where.user = 1;
            }
          } else {
            if (this.user.role == 5) {
              where.user = {
                $nin: [this.user._id, ...this.user.userInfo],
              };
            } else {
              where.user = { $nin: [this.user._id] };
            }
          }
        }
      }
      // if (this.user.role == 5) {
      //   if (!where.name && !where.user && !where.grade) {
      //     where.user = { $in: [...this.user.userInfo, this.user._id] };
      //   }
      // }
      console.log(where);
      this.query.where = where;
      this.query.page = 1;
      if (this.ids) {
        this.fetch(this.ids);
      } else if (this.createdAt) {
        this.fetch(this.createdAt);
      } else if (this.userName) {
        this.fetch();
      } else {
        this.fetch();
      }
    },
    async changPage({ pageSize, currentPage }) {
      this.query.page = currentPage;
      this.query.limit = pageSize;
      if (this.history_type == 6) {
        const res = await this.$http.get("customers/unsettled");
        this.ids = { _id: { $nin: res.data.ids }, isBlacklist: 0 };
        return this.fetch(this.ids);
      }
      this.fetch();
      // if (this.ids) {
      //   this.fetch(this.ids);
      // } else {
      //   this.fetch();
      // }
    },
    async detach(index) {
      try {
        await this.$confirm("是否确认删除？");
      } catch (e) {
        return;
      }
      const targetItem = this.history[index];
      if (!targetItem || !Array.isArray(this.formRow.history)) return;
      // computed history 排序后索引与 formRow.history 不一致，通过 _id 找到原始位置
      const originalIndex = this.formRow.history.findIndex(
        (item) => item._id && item._id === targetItem._id
      );
      if (originalIndex === -1) return;
      this.formRow.history.splice(originalIndex, 1);
      await this.$http.put(`customers/${this.formRow._id}`, this.formRow);
      this.$message.success("删除成功");
      this.fetch();
    },
    async onSubmit() {
      // 校验并规范化终端名称字段，避免后端校验失败
      if (!this.validateBusinessScopeOtherNames(this.formRow)) {
        return;
      }
      this.$clear(this.formRow, true);
      this.record.submitedAt = new Date();
      if (this.record && this.record.user == undefined) {
        this.record.user = this.user._id;
      }
      if (!this.formRow.history) {
        this.$set(this.formRow, 'history', []);
      }
      this.formRow.history.push(this.record);
      await this.$http.put(`customers/${this.formRow._id}`, this.formRow);
      const row = await this.$http.get(`customers/${this.formRow._id}`);
      this.formRow = row.data;
      this.$message.success("提交成功");
      this.record = {};
      this.fetch();
    },
    followUp(scope) {
      if (scope.row.isOperate == false && this.user.role !== 0) {
        this.$message.error("无操作权限");
      } else {
        this.formRow = scope.row;
        this.dialogVisible = true;
      }
    },

    // 筛选出期间段未联系的客户
    async fetchTime() {
      // this.history_type = this.$route.query.history_type;
      if ([10, 11, 12, 13, 14, 15, 16].includes(Number(this.history_type))) {
        this.query.where = {};
        if (this.where && this.where.$regex) {
          this.query.where.name = this.where.$regex;
        }
        return;
      }
      if (this.history_type == 6 && !this.wname) {
        if (!this.where && this.user.role !== 0 && !this.grade) {
          this.query.where = {
            user: 1,
            isBlacklist: 0,
          };
        }
        if (!this.where && this.user.role == 5 && !this.grade && !this.wname) {
          this.query.where = {
            user: 5,
            isBlacklist: 0,
          };
        }
      }

      const current = this.dayjs().toDate();
      const showWeek = async (current, timeFirst, timeEnd) => {
        let grade, name, user, where, total;
        if (this.grade) {
          grade = this.grade;
        }
        if (this.where) {
          name = this.where.$regex;
        }
        if (this.history_type == 9) {
          total = { $eq: 0 };
        }
        if (this.user.role == 0) {
          if (this.wname) {
            user = { $in: [this.wname] };
          }
        } else if (this.history_type !== "9") {
          user = 1;
        }

        if (this.history_type !== "9" && this.user.role == 5) {
          if (!this.wname) {
            user = 5;
          } else {
            user = { $in: [this.wname] };
          }
        }
        const isBlacklist = 0;
        if (current !== "notContacted") {
          where = {};
          const to = this.dayjs(current).subtract(...timeFirst);
          let from = {};
          if (timeEnd) {
            from = this.dayjs(current).subtract(...timeEnd);
            where = { $gte: from, $lte: to, $not: { $gte: to } };
          } else if (this.history_type == 7) {
            where = 7;
          } else {
            where = 6;
          }
        }
        const wheres = {
          "history.time": current !== "notContacted" ? where : { $exists: false },
          name,
          grade,
          user,
          total,
          isBlacklist,
        };
        this.query.where = wheres;
      };
      if (this.history_type == 1) {
        showWeek(current, [1, "week"], [2, "week"]);
      } else if (this.history_type == 2) {
        showWeek(current, [2, "week"], [1, "month"]);
      } else if (this.history_type == 3) {
        showWeek(current, [1, "month"], [2, "month"]);
      } else if (this.history_type == 4) {
        showWeek(current, [2, "month"]);
      } else if (this.history_type == 5) {
        showWeek("notContacted");
      } else if (this.history_type == 7) {
        showWeek(current, [1, "month"]);
      } else if (this.history_type == 6) {
        showWeek(current, [3, "month"]);
      } else if (this.history_type == 9) {
        showWeek(current, [1, "month"]);
      }
    },

    state() {
      if (!this.history_type && this.user.role !== 0 && this.user.role !== 6) {
        if (this.user.role !== 5 && this.permission == "me") {
          this.userName = {
            user: 1,
            isBlacklist: 0,
          };
        } else if (this.permission == "other" && this.user.role == 5) {
          this.userName = {
            user: { $nin: [this.user._id, ...this.user.userInfo] },
            isBlacklist: 0,
          };
        } else if (this.permission == "me" && this.user.role == 5) {
          this.userName = {
            user: 5,
            isBlacklist: 0,
          };
        } else {
          this.userName = {
            user: { $nin: [this.user._id] },
            isBlacklist: 0,
          };
        }
        this.fetch(this.userName);
      }
    },

    async fetchUser() {
      const ret = await this.$http.get(`users`, {
        params: {
          query: {
            limit: 0,
            where: {
              role: { $in: [1, 4, 5, 0] },
            },
          },
        },
      });
      const superintendent = ret.data.data;
      this.superintendents = superintendent;
    },

    async fetchCustomer() {
      this.history_type = this.$route.query.history_type;
      this.taskActionSceneReady = false;
      this.applyBlacklistTableMode(Number(this.history_type) === 14);
      // console.log( this.history_type)
      if (this.user.role == 6) {
        this.option.menu = false;
      }

      // 优先处理 customerId 参数
      const customerId = this.$route.query.customerId;
      if (customerId) {
        this.switchToCustomerView();
        await this.fetch();
        return;
      }

      if (this.history_type == 6) {
        await this.screen();
      } else if (this.history_type == 8) {
        let user = {};
        this.user.role == 5
          ? (user = 5)
          : this.user.role == 0
          ? (user = { $exists: true })
          : (user = this.user._id);

        this.createdAt = {
          createdAt: 8,
          user,
          isBlacklist: 0,
        };

        await this.fetch(this.createdAt);
      } else if ([10, 11, 12, 13, 14, 16].includes(Number(this.history_type))) {
        await this.fetch();
      }

      this.state();
      this.syncTaskActionSceneReady();
    },

    async fetchTeacher() {
      const { data } = await this.$http.get("teachers/option");
      this.teacherOptions = data;
    },

    monthCustomer() {},

    async fetchTest() {
      const res = await this.$http.get("customers/test");
    },

    fetchTree() {
      this.exportForm.field = importField.map((v) => {
        return v.value;
      });
      this.reservoirFrom.field = importField.map((v) => {
        return v.value;
      });
      this.exportotaltForm.field = importField.map((v) => {
        return v.value;
      });
    },

    async fetch(where = {}) {
      this.fetchTime();
      this.loading = true;
      if (this.history_type == 6) {
        delete where._id;
        where.history_type = this.history_type;
      }
      if ([10, 11, 12, 13, 14, 16].includes(Number(this.history_type))) {
        where.history_type = this.history_type;
      }
      Object.assign(this.query.where, where);
      const customerId = this.$route.query.customerId;
      if (customerId) {
        const res = await this.$http.get(`customers/${customerId}`);
        let data = res.data;
        if (data) {
          this.formRow = data;
          this.query.where = { _id: this.formRow._id };
          // this.query.sort = {'history.followUp_type':-1}
          this.dialogVisible = true;
        } else {
          // If customer not found, clean up the query to avoid empty list
          delete this.query.where._id;
        }
      }

      if (this.sortOrder == 1) {
        this.query.sort = { ...this.query.sort };
      } else {
        this.query.sort = { ...this.query.sort };
      }
      this.query.collation = { locale: "zh" };
      const res = await this.$http.get("customers", {
        params: {
          query: JSON.stringify(this.query),
        },
      });
      this.page.total = res.data.total;
      const customers = res.data.data;
      const form = [...this.user.userInfo, this.user._id];

      console.log(customers.length, "customers");
      const yCustomers = customers.map((v) => {
        if (
          v.user &&
          v.user.find((v) =>
            this.user.role == 5 ? form.includes(v._id) : v._id == this.user._id
          )
        ) {
          return v;
        } else if (this.user.role !== 0) {
          if (v.contacts && Array.isArray(v.contacts)) {
            for (const item of v.contacts) {
              delete item.mobile;
            }
          }
          v.isOperate = false;
          return v;
        }
      });

      // let yCustomers = [];
      // let nCustomers = [];
      // customers.forEach((v) => {
      //   if (v.user && v.user.find((v) => v._id == this.user._id)) {
      //     yCustomers.push(v);
      //   } else {
      //     nCustomers.push({
      //       _id: v._id,
      //       name: v.name,
      //       user: v.user,
      //     });
      //   }
      // });

      if (this.user.role == 0) {
        this.data = customers;
      } else {
        this.data = yCustomers;
      }

      this.loading = false;

      this.data = this.data.map((v) => {
        return {
          ...v,
          id: v._id,
        };
      });

      // console.log(this.data,'data')

      const ret = await this.$http.get(`home/customer_option`);
      let cardDate = ret.data;
      this.customerData = cardDate.customerData;
      this.syncTaskActionSceneReady();
      // console.log(this.customerData);
      // this.customerData.data.map((v) => {
      //   if (v.to) {
      //     v.click = () => this.$router.push(v.to);
      //   }
      // });

      // this.data = Ycustomers

      // this.data = res.data.data;
      // this.fetchCustomer();
    },
    to(item) {
      const targetHistoryType = this.getStatHistoryType(item);
      this.applyBlacklistTableMode(targetHistoryType === 14);
      if (item.to) {
        const path = this.$route.fullPath;

        if (path !== item.to) {
          this.$router.push(item.to);
        }
        this.fetchCustomer();
        if (
          this.history_type == 9 ||
          this.history_type == 7 ||
          [10, 11, 12, 13, 14, 16].includes(Number(this.history_type))
        ) {
          this.fetch();
        }
        // this.fetch();
      }
    },
    async fetchType() {
      const res = await this.$http.get("dictionaries/type/contact.way");
      this.options = res.data.sort();
    },
    async fetchGradeDict() {
      const res = await this.$http.get("dictionaries/type/customer.grade");
      this.gradeDict = res.data || [];
    },
    async remove(row) {
      if (this.user.role !== 0) {
        this.$message.error("无操作权限");
      } else {
        try {
          await this.$confirm("是否确认删除？");
        } catch (e) {
          return;
        }
        await this.$http.delete(`customers/${row._id}`);
        this.$message.success("删除成功");
        this.fetch();
      }
    },
    async takeOver(scope) {
      try {
        await this.$confirm("是否确认接管负责人？");
      } catch (e) {
        return;
      }
      this.$clear(scope.row);
      scope.row.user = this.user._id;
      await this.$http.put(`customers/${scope.row._id}`, scope.row);
      this.$message.success("提交成功");
      this.fetch();
    },
    async relieve(scope) {
      try {
        await this.$confirm("是否确认解除负责人？");
      } catch (e) {
        return;
      }
      this.$clear(scope.row);
      scope.row.user = [];
      await this.$http.put(`customers/${scope.row._id}`, scope.row);
      this.$message.success("解除成功");
      this.fetch();
    },
    async update(row, index, done) {
      this.$clear(this.form);
      if (this.form.source !== "客户转介") {
        delete this.form.referrer;
      }
      if (this.form.hasBranch !== "是") {
        this.form.branchProvinceCity = [];
      }
      if (!this.form.isBlacklist && this.form.isBlacklist !== 0) {
        this.form.isBlacklist = 0;
      }
      this.form.deepTillArea = this.normalizeDeepTillArea(
        this.form.deepTillArea
      );
      if (!this.validateBusinessScopeOtherNames(this.form)) {
        return;
      }
      await this.$http.put(`customers/${this.form._id}`, this.form);
      this.$message.success("更新成功");
      this.fetch();
      done();
    },
    async create(row, done) {
      try {
        // 使用 this.form 而不是 row，确保 formslot 中的数据被正确收集
        const form = this.form;
        if (form.source !== "客户转介") {
          delete form.referrer;
        }
        if (form.hasBranch !== "是") {
          form.branchProvinceCity = [];
        }
        if (!form.isBlacklist && form.isBlacklist !== 0) {
          form.isBlacklist = 0;
        }
        form.deepTillArea = this.normalizeDeepTillArea(form.deepTillArea);
        if (!this.validateBusinessScopeOtherNames(form)) {
          return;
        }
        await this.$http.post("customers/isExist", form);

        await this.$http.post("customers", form);
        this.$message.success("创建成功");
        this.fetch();
        done();
      } catch {}
    },
  },
  beforeDestroy() {
    this.stopTaskProgressTimer();
    window.removeEventListener(
      "customer-link-task-realtime",
      this.handleTaskRealtime
    );
  },
  created() {
    this.fetchCustomer();
    // this.fetchCity()
    // this.fetch();
    this.fetchUser();
    this.fetchType();
    this.fetchGradeDict();
    this.fetchTree();
    this.fetchTeacher();
    window.addEventListener(
      "customer-link-task-realtime",
      this.handleTaskRealtime
    );
    // this.fetchTest();
  },
  activated() {
    this.fetchCustomer();
  },
};
</script>

<style>
.hide-province-checkbox .el-cascader-menu:first-child .el-checkbox {
  display: none !important;
}
.task-create-selected {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
}

.task-action-group {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 8px;
  margin-left: 8px;
}

.task-action-item {
  display: inline-flex;
}

.task-action-button {
  transition: background-color 200ms ease, box-shadow 200ms ease, opacity 200ms ease;
}

.task-action-button.is-disabled,
.task-action-button.is-disabled:hover,
.task-action-button.is-disabled:focus {
  opacity: 0.6;
  cursor: not-allowed;
}

.task-action-fade-enter-active,
.task-action-fade-leave-active {
  transition: opacity 300ms ease-in-out;
}

.task-action-fade-enter,
.task-action-fade-leave-to {
  opacity: 0;
}

.task-result-box {
  background: #f7f9fc;
  border-radius: 8px;
  padding: 12px;
}

.task-type-form-item {
  flex-direction: column;
}

.task-type-form-item .el-form-item__content {
  margin-left: 0 !important;
}

.task-type-label {
  font-weight: 600;
  margin-bottom: 4px;
}

.task-type-radio-group {
  display: block;
}

.task-result-item {
  color: #f56c6c;
  line-height: 22px;
}

.task-progress-wrap {
  padding: 0 20px 20px;
}

.task-progress-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.task-progress-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  background: #fff;
}

.task-progress-card.active {
  border-color: #409eff;
  box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.1);
}

.task-progress-card.success.active {
  border-color: #67c23a;
}

.task-progress-card.warning.active {
  border-color: #e6a23c;
}

.task-progress-card.danger.active {
  border-color: #f56c6c;
}

.task-progress-label {
  color: #909399;
  margin-bottom: 8px;
}

.task-progress-value {
  font-size: 26px;
  font-weight: 600;
  color: #303133;
}

.task-progress-rate-text {
  margin-bottom: 10px;
  color: #303133;
  font-weight: 600;
}

.task-detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.task-detail-row span {
  color: #909399;
}

.task-detail-text {
  background: #f7f9fc;
  border-radius: 8px;
  padding: 14px;
  line-height: 22px;
  white-space: pre-wrap;
}

.business-scope-other-inputs {
  width: 100%;
}

.business-scope-other-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 8px;
}

.business-scope-other-label {
  min-width: auto;
  color: #606266;
  margin-right: 0;
  white-space: nowrap;
}

.business-scope-other-input {
  width: 360px;
  max-width: 100%;
}

.business-scope-child-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.business-scope-child-select {
  width: 360px;
  max-width: 100%;
}

.business-scope-child-prefix {
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
}

@media only screen and (max-width: 768px) {
  .contact {
    display: inline !important;
  }

  .history-info {
    display: inline !important;
  }

  .pdl-3 {
    padding-left: 0 !important;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 10px !important;
  }

  /* .el-input__inner {
    padding: 0 10px !important;
  } */
}

.el-button [class*="iconfont"] + span {
  margin-left: 5px;
}

.createdAt {
  color: #555;
}

.block {
  height: 50vh;
  overflow: scroll;
}

.block::-webkit-scrollbar {
  width: 0 !important;
}

.el-input--suffix .el-input__inner {
  padding-right: 24px;
}

.customer .el-dialog__body .el-form-item__label {
  width: auto !important;
}

.customer .el-dialog__body .el-form-item__content {
  margin-left: auto !important;
}

.history-info {
  display: flex;
}

.pdl-3 {
  padding-left: 1rem;
}

.sort-order label {
  margin-bottom: 0 !important;
}
.customer {
  overflow: hidden;
}
</style>
  
